/* eslint-disable no-param-reassign */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-shadow */
import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useDispatch, useSelector, connect } from 'react-redux';
import './EpikboxOptions.css';
import { Button, Col, Row, Tooltip, Input, Label, Alert, FormGroup } from 'reactstrap';
import { toast } from 'react-toastify';
import moment from 'moment';
import DropdownSelect from '../../../../ProposalGenerator/DropdownSelect';
import AddSecurityCodeModal from '../../../../AddSecurityCodeModal';
import CustomModal from '../../../../CustomModal';
import * as BoxesActions from '../../../../../actions/EpikBoxes';
import SpinnerCircles from '../../../../Spinner/SpinerCircles';
import MultiInputDrag from '../../../../MultiInputDrag';
import BoxAutocomplete from '../../../BoxAutocomplete';
import { clearAddress, getAddress, updateAddress } from '../../../../../actions/Provisioning';
import E911AddressModal from '../../../../E911AddressModal';
import ConfirmationModal from '../../../../ConfirmationModal';
import Toggle from '../../../../Toggle';
import {
  addAction,
  changeAction,
  enableAction,
  disableAction,
} from '../../../../../actions/BoxSessionLogging';
import Spinner from '../../../../Spinner/Spinner';
import DynamicAutoComplete from '../../../DynamicAutoComplete';
import utils from '../../../../../lib/utils';
import { DATA_LATENCY_TYPE, TOOLTIPS_TEXT } from '../../../../../lib/constants';

import { obisToPort } from '../EpikBoxPorts';
import WarningModal from '../../../../WarningModal';
import InfoPopup from '../../../../InfoPopup';
import EnhancedRouting from './EnhanceRouting';
import BoxRegistrar from './BoxRegistrar';
import powerCycle from '../../../../../Res/Icon/Power-Cycle.svg';
import save from '../../../../../Res/Icon/Save.svg';
import softReboot from '../../../../../Res/Icon/Soft-Reboot.svg';
import applyUpdates from '../../../../../Res/Icon/Firmware.svg';
import suspend from '../../../../../Res/Icon/Suspend-Service.svg';
import BandManagementWarningModal from '../../../../BandManagementWarningModal';
import { set } from 'lodash';
import { PIN_CODES_NAME } from '../../../../../utils/constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { timezoneOptions } from '../../../constants';
import { useUnifiedMutate } from '../../../../../hooks/useUnifiedMutate';
import { useUnifiedFetch } from '../../../../../hooks/useUnifiedFetch';
import addBoxAction from '../../../../../lib/api/addBoxAction';
import * as ProvisioningActions from '../../../../../actions/Provisioning';
import addDeviceActivityNote from '../../../../../lib/api/addNote';
import { faRedo, faPlus } from '@fortawesome/free-solid-svg-icons';
import PowerSaverSchedule from './PowerSaverSchedule';
import CountDownTimer from '../../../../CountDownTimer/countDownTimer';
import alertErrorMessageWarning from '../../../../../Res/Icon/alertErrorMessageWarning.svg';
import { getPermissionForComponent } from '../../../../../utils/permissionsUtils';

const DEVICE_UNAVAILABLE_FORWARD_ERROR = 'Must be a number not assigned to this EPIK Edge Device';

const DIGITS_ONLY = /\D+/g;
const sanitizeDigits = (s) => String(s || '').replace(DIGITS_ONLY, '');
const phoneNumbersMatch = (a, b) => {
  const da = sanitizeDigits(a);
  const db = sanitizeDigits(b);
  if (!da || !db) return false;
  if (da === db) return true;
  if (da.length >= db.length) return da.endsWith(db);
  return db.endsWith(da);
};

const APNItems = [
  { label: 'Select Carrier', value: '' },
  { label: 'Verizon', value: 'verizon' },
  { label: 'T-Mobile', value: 'tmobile' },
  { label: 'Telus', value: 'telus' },
  { label: 'AT&T', value: 'atnt' },
];
const carrierAPNs = {
  verizon: [
    { label: 'Select any APN', value: '' },
    { label: 'Custom', value: 'custom' },
    { label: 'ne01.vzwstatic', value: 'ne01.vzwstatic' },
    { label: 'we01.vzwstatic', value: 'we01.vzwstatic' },
    { label: 'mw01.vzwstatic', value: 'mw01.vzwstatic' },
    { label: 'vzwinternet', value: 'vzwinternet' },
    { label: 'GRTEPIKE.VZWENTP', value: 'GRTEPIKE.VZWENTP' },
    { label: 'GRTEPIKC.VZWENTP', value: 'GRTEPIKC.VZWENTP' },
    { label: 'GRTEPIKW.VZWENTP', value: 'GRTEPIKW.VZWENTP' },
    { label: 'so01.vzwstatic', value: 'so01.vzwstatic' },
  ],
  tmobile: [
    { label: 'Select any APN', value: '' },
    { label: 'Custom', value: 'custom' },
    { label: 'iot.granite.static', value: 'iot.granite.static' },
    { label: 'b2b.static', value: 'b2b.static' },
    { label: 'fast.t-mobile.com', value: 'fast.t-mobile.com' },
  ],
  telus: [
    { label: 'Select any APN', value: '' },
    { label: 'Custom', value: 'custom' },
    { label: 'pse.telus.iot', value: 'pse.telus.iot' },
  ],
  atnt: [
    { label: 'Select any APN', value: '' },
    { label: 'Custom', value: 'custom' },
    { label: '11166.mcs', value: '11166.mcs' },
  ],
};
const SIMItems = [{ label: 'Select SIM', value: '' }, { label: 'SIM 1', value: 1 }, { label: 'SIM2', value: 2 }];
const datacenters = [
  { label: 'Los Angeles', value: 'la' },
  { label: 'Chicago', value: 'ch' },
  { label: 'New York', value: 'ny', disabledItem: false },
  { label: 'Atlanta', value: 'at', disabledItem: false },
  { label: 'Dallas', value: 'dl', disabledItem: false },
];

const warningText = {
  msg: `*Client must have address for their edge device set to:
IP: 172.17.17.100
mask: 255.255.255.0
gateway: 172.17.17.254
or system will not connect.`,
  type: 'E2',
};

const datacenterWarningText = {
  header: "Device Registration",
  subHeader: ``,
  msg:
    'This action is service affecting. Once complete, ensure the device is online by verifying ping. Faxing services will be migrated to Enhanced Fax Protocol. Fax services may be disrupted during the move process.',
  type: 'datacenter',
};

const warningMonitoringTxt = {
  msg:
    'Warning: Do Not Enable monitoring if the EPIK Edge Device is not confirmed online or the Turn up has not been completed and all tests passed. Doing so could generate false alerts. Are you sure want to proceed?',
  type: 'monitoring',
};

const warningEnhancedFax = {
  msg:
    'Warning: Enabling to Enhanced Fax Service will cause disruption to current Fax services. Are you sure you want to continue?',
  type: 'enhancedFax',
};

const warningDisableEnhancedFax = {
  msg:
    'Disabling Enhanced Fax will disrupt fax capabilities and all enhanced functionality. Please consult with engineering before proceeding. Are you sure you want to proceed with Disabling Enhanced Fax?',
  type: 'disableEnhancedFax',
};

const warningAdvancedMonitoringTxt = {
  msg:
    'Attention: Do no enable Advanced Monitoring without prior authorization from Tier 3 support. Advanced Monitoring could cause high bandwidth utilization if running on 4G LTE. Are you sure you want to Proceed?',
  type: 'advancedMonitoring',
};

const warningHardReset = {
  msg:
    'Are you sure you want to perform a hard reset? This will interrupt service on the device until the reboot cycle is complete',
  type: 'hardReset',
};

const suspendedTxt = {
  msg:
    'WARNING: Suspending service will shut off all services to the EPIK Edge Device. Are you sure you want to continue?',
  type: 'suspension1',
};

const suspendedTxt1 = {
  msg: 'Are you sure you want to proceed with service suspension?',
  type: 'suspension2',
};

const restoreSuspension = {
  msg: 'Service will be restored to the Edge device. Are you sure you want to continue?',
  type: 'restore',
};

const secondarySwitch = {
  type: 'secondary',
};

const OOBM_DISABLE_TEXT = `Disabling OOBM with BTN\'s connected will cause all endpoints to become inaccessible. Are you sure you want to proceed with disabling the OOBM feature?`;

const ENABLE_EXPANSION_WARNING_TEXT = `Epik Device will need to be rebooted for changes to take effect.`;

/* CONSTANTS */
const IGNORE_INFO_TOASTER = true;
const SIXTY_SECONDS_DELAY = 60_000;
const BAND_MANAGEMENT = 'bandManagement'
const DATA_CENTER = 'datacenter'
const omitLeading9 = "omitLeading9"

const EpikboxOptions = ({
  box,
  onConfirm,
  editOptionsChange,
  optionsBoxChange,
  setInterfacePriority,
  boxHardReset,
  getInterfacePriority,
  getInterfacePriorityIsp,
  advancedMonitoring,
  priStatusCheck,
  advMonitoring,
  enableToggleLoader,
  enableBoxEdit,
  onReboot,
  onApplyUpdate,
  onFailoverInstall,
  getCarrier,
  getCurrentApn,
  setCarrier,
  numbers,
  updateAddress,
  clearAddress,
  addressModalData,
  updateBox,
  updateInterCalling,
  activateE2,
  deactivateE2,
  activateE3,
  deactivateE3,
  disableRecording,
  boxesSerial,
  enableRecording,
  user,
  addAction,
  disableAction,
  enableAction,
  addNote,
  changeAction,
  getEpikBoxesBySerialNumber,
  boxLock,
  eSIMStatus,
  getPrimarySim,
  setPrimarySim,
  rebootEpikBox,
  secondaryTunnel,
  secondaryTunnelStatus,
  getBoxesSerialNumber,
  eSIMStatusPing,
  getAddress,
  boxESimStatus,
  enableStarCodes,
  enableBoxCallForward,
  resetStarCodes,
  centerLatency,
  boxActiveSimStats,
  bandManagementStatus,
  OOBManagerHandler,
  removeOob,
  updateOOBDetail,
  oobLoadingHandler,
  oobLoading,
  assignedCompanyNumbers,
  ext_9override,
  updateDbcaAlert,
  removeNumberAddress,
  getAdminFlags,
  GeocodeRequest,
  getEpikBoxData,
  pendingFaxData,
}) => {
  const [carrierType, setCarrierType] = useState(APNItems[1]);
  const [simType, setSimType] = useState(SIMItems[0]);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [dc, setDc] = useState(datacenters.find(dc => dc.value == box?.datacenter));
  const [simActiveLoading, setSimActiveLoading] = useState(false);
  const [voiceIndicator, setVoiceIndicator] = useState(false);
  // const [interfacePriority, setInterfacePriorityState] = useState(null);
  const [enableInhouseToggler, setEnableInhouseToggler] = useState(false);
  const [enablePortForwardToggler, setEnablePortForwardToggler] = useState(false);
  const [APNString, setAPNString] = useState('');
  const [APNCurrentString, setAPNCurrentString] = useState('');
  const [e2Strings, setE2Strings] = useState(
    box?.e2 || {
      enabled: false,
      IP: '',
      subnet: '',
      gateway: '',
    },
  );
  const [isModelGen4, setIsModelGen4] = useState(box?.model?.startsWith("G4"));

  const [isUpdateBtnDisable, setIsUpdateBtnDisable] = useState(false);
  const [currentModalData, setCurrentModalData] = useState({});
  const [passwordModalStatus, setPasswordModalStatus] = useState(false);
  const [enableE2Btn, setEnableE2Btn] = useState(true);
  const [priStatus] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [tooltipOpenPower, setTooltipOpenPower] = useState(false);
  const [tooltipOpenSave, setTooltipOpenSave] = useState(false);
  const [tooltipOpenSuspend, setTooltipOpenSuspend] = useState(false);

  const [tooltipOpenM, setTooltipOpenM] = useState(false);
  // const [eSIMStatusValue, setESIMStatusValue] = useState('');
  const [simHistory, setSimHistory] = useState('');
  const [recordingTooltipOpen, setRecordingTooltipOpen] = useState(false);
  const [failoverStatus, setFailoverStatus] = useState(false);
  const [showQueryLrnModal, setShowQueryLrnModal] = useState(false);
  const [selectedNumberId, setSelectedNumberId] = useState();
  const [warningStatus, setWarningStatus] = useState(false);
  const [suspendModal, setSuspendModal] = useState(false);
  const [isCallRecorderLoading, setIsCallRecorderLoading] = useState(false);
  const [recordingModal, setRecordingModal] = useState(false);
  const [note, setSuspensionNote] = useState('');
  const [secTunnel, setSecTunnel] = useState(false);
  const [portLoading, setPortLoading] = useState(false);
  const [portAlerts, setPortAlerts] = useState(null);
  const [offlineProv, setOfflineProv] = useState(null);
  const [boxOptions, setBoxOptions] = useState({
    ...box,
    monitor: box?.monitor,
    recording: box?.recording,
    inhouseProvision: box?.inhouseProvision || false,
    e911Number: box?.e911Number || null,
    e2: e2Strings,
    e3: box?.e3 || false,
    expansionBox: box?.expansionBox || '',
    starCode: box?.starCodes || false,
  });
  const [interDialing, setInterDialing] = useState(box?.internationalDialing || false);
  const [enableExpansionBox, setEnableExpansionBox] = useState(!!box?.expansionBox);
  const [enableOfflineBoxCallForward, setEnableOfflineBoxCallForward] = useState(box?.boxOfflineCallForward);
  const [boxOfflineCallForwardNumber, setBoxOfflineCallForwardNumber] = useState(box?.boxOfflineCallForwardNumber);

  const [enableEnhanceRouting, setEnableEnhanceRouting] = useState(box?.advancedRouting);
  const [simOpenTooltip, setSimOpenTooltip] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isExpandingBox, setIsExpandingBox] = useState(false);
  const [simToggleLoading, setSimToggleLoading] = useState(false);
  const [numberConfirmation, setNumberConfirmation] = useState(false);
  const [reloadSimStatus, setReloadSimStatus] = useState(false);
  const [starToggleLoading, setStarToggleLoading] = useState(false);
  const [starResetLoading, setStarResetLoading] = useState(false);
  const [centerLatencyState, setcenterLatencyState] = useState({});
  const [customApnNameSelection, setCustomApnNameSelection] = useState(false);
  const [tooltipOpenSoft, setTooltipOpenSoft] = useState(false);
  const [tooltipOpenUpdate, setTooltipOpenUpdate] = useState(false);
  const [apnNameOptions, setApnNameOptions] = useState([]);
  const [activeCarrier, setactiveCarrier] = useState(null);
  const [newActiveCarrier, setNewActiveCarrier] = useState('');
  const [newActiveCarrierAPN, setNewActiveCarrierAPN] = useState('');
  const [loadingText, setLoadingText] = useState('');
  const [remoteCallOverflowToggle, setRemoteCallOverflowToggle] = useState(false); // Initialize the toggle as false
  const [phoneNumber, setPhoneNumber] = useState(''); // State to store the entered phone number

  const [extLoading, setExtLoading] = useState(false);
  const [enable3DigitDialing, setEnable3DigitDialing] = useState(box?.threeDigitDialing?.enabled || false);
  const [threeDigitDialingEntries, setThreeDigitDialingEntries] = useState([{ code: '', redirectTo: '' }]);
  const [threeDigitDialingLoading, setThreeDigitDialingLoading] = useState(false);
  const [show3DigitDialingConfirmModal, setShow3DigitDialingConfirmModal] = useState(false);
  const [extValue, setExtValue] = useState(box?.ext_9override ?? false);
  const hasPendingFaxes = Array.isArray(pendingFaxData) && pendingFaxData.length > 0;
  // Custom hooks for 3-digit dialing API calls
  const { data: threeDigitDialingData, fetchData: fetchThreeDigitDialing } = useUnifiedFetch(
    `boxes/${box?._id}/fetch3digitdiallinglist`,
    false // Don't auto-fetch on mount
  );
  const { mutate: updateThreeDigitDialing, isLoading: isUpdatingThreeDigitDialing } = useUnifiedMutate();

  // Load 3-digit dialing data when component mounts
  useEffect(() => {
    if (box?._id) {
      fetchThreeDigitDialing();
      getEpikBoxData(token, box?._id);
    }
  }, [box?._id, fetchThreeDigitDialing]);

  // Update local state when API data changes
  useEffect(() => {
    if (threeDigitDialingData) {
      // Check if response contains an error message
      if (threeDigitDialingData.ErrorMessage) {
        // If there's an error, set empty fields
        setThreeDigitDialingEntries([{ code: '', redirectTo: '' }]);
        return;
      }
      
      // Convert entries object to array format for UI
      if (threeDigitDialingData && typeof threeDigitDialingData === 'object') {
        const entriesArray = Object.entries(threeDigitDialingData).map(([code, redirectTo]) => ({
          code,
          redirectTo
        }));
        setThreeDigitDialingEntries(entriesArray.length > 0 ? entriesArray : [{ code: '', redirectTo: '' }]);
        setEnable3DigitDialing(entriesArray.length > 0 ? true : false);
      } else {
        setThreeDigitDialingEntries([{ code: '', redirectTo: '' }]);
      }
    }
  }, [threeDigitDialingData]);

  const [isE911Verified, setIsE911Verified] = useState(false);
  const [hideE911Loader, setHideE911Loader] = useState(false);
  const [customApn, setCustomApn] = useState(false);
  const [epitTimezoneLoading, setEpiTimezoneLoading] = useState(false);
  const [epitTimezoneValue, setEpiTimezoneValue] = useState(timezoneOptions.find(ob => ob.value === box?.epiTimezone));
  const [isPowerSaveOn, setIsPowerSaveOn] = useState(false);
  const [selectedPowerSaveMode, setSelectedPowerSaveMode] = useState();
  const [recordingDuration, setRecordingDuration] = useState(24); // Default value is 24
  const [isToggleOn, setIsToggleOn] = useState(boxOptions.recording);
  const [disableExpansionModule, setDisableExpansionModule] = useState(false);
  const [deviceEpikUpdates, setDeviceEpikUpdates] = useState(
    typeof box?.epikUpdateStatus === 'boolean' ? box.epikUpdateStatus : null
  );

  const priSettings = useSelector(state => state.AppState.priSipData?.priSettingData);
  const sipSettings = useSelector(state => state.AppState.priSipData?.sipSettingData);

  const { mutate: callPowerSaveModeApi, isLoading: isUpdatingPowerSaveMode } = useUnifiedMutate();
  const endpoint = `boxes/${box?.serialNumber}/automaticFwTime`;
  const { data: automaticFwDate, fetchData: fetchAutomaticFwDate } = useUnifiedFetch(endpoint, undefined, false);
  const { mutate: requestPowerSaver, isLoading: isPSLoading } = useUnifiedMutate();
  const omitLeading = getPermissionForComponent('omitLeading',user.permissionsGroup);
  const registrationOffSet = getPermissionForComponent('registrationOffSet',user.permissionsGroup);
  const powerSave = getPermissionForComponent('powerSave',user.permissionsGroup);
  const internationalDialingAccess = getPermissionForComponent('internationalDialingAccess',user.permissionsGroup);
  const enableMonitoring = getPermissionForComponent('enableMonitoring',user.permissionsGroup);
  const outBandManagement = getPermissionForComponent('outBandManagement',user.permissionsGroup);
  const dataCenter = getPermissionForComponent('dataCenter',user.permissionsGroup);
  const { data: epikUpdates, fetchData: getEpikUpdates } = useUnifiedFetch(`boxes/${box?._id}/epik-updates`, true);
  const [showModal1, setShowModal] = useState(false);
  const [showAddressModal, setShowAddressModal] = useState(false);
const [showValidationModal, setShowValidationModal] = useState(false);
const [suggestedData, setSuggestedData] = useState();
const [enableExpansionWarning, setEnableExpansionWarning] = useState(false);



  const makePowerSaverRequest = async (action, payload={}) => {
    if(isLoading){
      return;
    }

    const endpoint = `boxes/power-saver/${box?._id}?action=${action}`;
    const method = 'POST';

    let response = await requestPowerSaver({
      isMyEpik: false,
      endpoint,
      method,
      body: payload,
    });

    return response
  }

  const dispatch = useDispatch();
  const fetchDataCenterLatency_ = async (
    boxId,
    type = DATA_LATENCY_TYPE.GET_LATENCY,
    ignoreInfoFlag = false,
  ) => dispatch(BoxesActions.fetchDataCenterLatency(boxId, true, undefined, type, ignoreInfoFlag));
  const resetDataCenterLatency_ = async () => dispatch(BoxesActions.resetDataCenterLatency());

  const dataCenterState = useSelector(state => state.AppState.boxDetails.dataCenterLatency);
  const { loading: dcLoading } = dataCenterState;
  const [dcOptionsWithLatency, setDcOptionsWithLatency] = useState(datacenters);
  const [dataCenterLatency, setDataCenterLatency] = useState({});
  const [dcUpdatePopup, setDcUpdatePopup] = useState({ show: false, value: {} });
  const [showIcon, setShowIcon] = useState(box?.OBEnable);
  const [dbcaAlert, setDbcaAlert] = useState(box?.dbcaAlerts || false);
  const [dcLockUpdatePopup, setDcLockUpdatePopup] = useState({ show: false, value: {} });
  const [isPowerSaverModalOpen, setPowerSaverModal] = useState(false);
  const [powerSchedule, setPowerSchedule] = useState({});

  const interfacePriority = useSelector(state => state.UIState.epikBoxes.interfacePriority);
  const setInterfacePriorityState_ = data => dispatch(BoxesActions.setInterfacePriorityState(data));

  const [oobmTogglerValue, setOobmTogglerValue] = useState(showIcon || box?.OBEnable);
  const obisList = () => {
    const obisList = box?.Obis?.map(obis => {
      return [obis?.port1, obis?.port2];
    });
    const flatArray = obisList?.flat();
    const isVoice = flatArray?.some(obis => {
      return obis?.assignedNumberRef?.type === 'voice';
    });
    setVoiceIndicator(isVoice);
  };
  const callRecordingDefaultValue = 24;
  useEffect(() => {
    obisList();
    const checkThirdOctet = parseInt(box?.vpnAddress?.split('.')[2], 10) >= 20;
    if (checkThirdOctet) {
      fetchDataCenterLatency_(box?._id, DATA_LATENCY_TYPE.GET_LATENCY, IGNORE_INFO_TOASTER);
      setcenterLatencyState(dataCenterState);
      return () => {
        resetDataCenterLatency_();
      };
    }
  }, []);

  useEffect(() => {
    setDataCenterLatency({
      la: dataCenterState?.data?.laPingAvg,
      ch: dataCenterState?.data?.chPingAvg,
      ny: dataCenterState?.data?.nyPingAvg,
      dl: dataCenterState?.data?.dlPingAvg,
    });

    const state_ = dcOptionsWithLatency.map(val => {
      // Find the corresponding datacenter object based on value
    const matchingDatacenter = datacenters.find(dc => dc.value === val.value);
      console.log("val::",val)
      let temp = `${val.value}PingAvg`;
      return {
        ...val,
        label: matchingDatacenter.label + `${dataCenterState?.data[temp] ? `- ${dataCenterState?.data[temp]}ms` : ''} `,
      };
    });
    console.log('state_ dcCenter::', state_);
    setDcOptionsWithLatency(state_);
    setcenterLatencyState(dataCenterState);
  }, [dataCenterState,user]);

  const [spinnerMsg, setSpinnerMsg] = useState('Please wait, this could take up to 20 seconds');
  const initialRender = useRef(true);
  let defaultInterfacePriorite = null;
  const token = localStorage.getItem('jwtToken') || null;
  const isNumberKey = evt => {
    const charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57)) return false;
    return true;
  };

  useEffect(() => {
    if (e2Strings.IP.length > 0 && e2Strings.subnet.length > 0 && e2Strings.gateway.length > 0) {
      setEnableE2Btn(false);
    } else {
      setEnableE2Btn(true);
    }
    setBoxOptions({ ...boxOptions, e2: e2Strings });
  }, [e2Strings]);

  useEffect(() => {
    if (box?._id) {
      fetchPrimarySim();
    }
  }, [box?._id]);

  const fetchPrimarySim = async () => {
    try {
      const response = await getPrimarySim(token, box?._id);
      if (response && response['Primary SIM'] !== undefined) {
        const primarySimIndex = parseInt(response['Primary SIM'], 10);
        if (!isNaN(primarySimIndex) && SIMItems[primarySimIndex]) {
          setSimType(SIMItems[primarySimIndex]);
        } else {
          setSimType(SIMItems[0]);
        }
      } else {
        toast.error(`Not able to fetch Primary SIM`);
        setSimType(SIMItems[0]);
      }
    } catch (error) {
      toast.error(`Error getting Primary Sim ${error?.message}`);
      setSimType(SIMItems[0]);
    }
  };

  const one2InputChange = name => {
    const lastLetter = name.target.value.charAt(name.target.value.length - 1);
    const numberCheck = !isNaN(lastLetter);
    if (numberCheck || lastLetter === '.') {
      setE2Strings({ ...e2Strings, [name.target.name]: name.target.value });
    } else {
      toast.error('Please enter number or dot');
    }
  };

  const onCallRecordingToggle = async () => {
    setIsExpandingBox(true);
    setIsCallRecorderLoading(true);
    let isTrue = false;
    if (boxOptions.recording) {
      console.log('disabled')
      const isDisabled = await disableRecording(token, box?._id);
      if (isDisabled) {
        // [Action]- Disable
        disableAction(
          `Call recording change from ${boxOptions.recording ? 'enabled' : 'disabled'} to ${boxOptions.recording ? 'disabled' : 'enabled'
          } `,
        );
        setIsToggleOn(false)
        setBoxOptions({ ...boxOptions, recording: !boxOptions.recording, recordingDuration: !boxOptions.recordingDuration });
        setRecordingDuration(callRecordingDefaultValue)
        getAdminFlags(token, box?._id)
      }
    } else {
      // setRecordingModal(true);
      console.log('enabled')
      const updatedObject = await enableRecording(token, box?._id, recordingDuration);

      if (updatedObject) {
        // [Action] - Enable
        enableAction(
          `Call recording change from ${boxOptions.recording ? 'enabled' : 'disabled'} to ${boxOptions.recording ? ' disabled ' : 'enabled'
          }  `,
        );
        getAdminFlags(token, box?._id)
        setBoxOptions({ ...boxOptions, recording: updatedObject.recording, recordingDuration: updatedObject.recordingDuration });
      }
    }

    setIsCallRecorderLoading(false);
    setIsExpandingBox(false);
  };
  const handleToggle = (value) => {
    if(value == false){
      setIsToggleOn(true)
    }else{
      if(boxOptions.recording){
        onCallRecordingToggle()
      }else{
      setIsToggleOn(false)
      }
    }
  };


  const toggleRecordingTooltip = () => {
    setRecordingTooltipOpen(!recordingTooltipOpen);
  };

  const geteSIMStatus = async () => {
    setIsExpandingBox(true);
    setSimToggleLoading(true);
    setReloadSimStatus(true);
    await fetchPrimarySim();
    setReloadSimStatus(false);
    // setESIMStatusValue(boxESimStatus);
    setSpinnerMsg('Please wait, this could take up to 20 seconds');
    setIsExpandingBox(false);
  };

  const onReloadStatus = () => {
    setReloadSimStatus(true);
    geteSIMStatus();
  };

  const handleActiveSim = async (shouldBoot = false, showSpinner = true) => {
    if (simType?.value !== '') {
      if (showSpinner) setSimActiveLoading(true);
      const simStatus = simType.value !== 1;
      const response = await setPrimarySim(token, simType?.value, box?._id);

      if (response && response?.modified === true) {
        const activity = `eSIM changed from ${simStatus ? 'SIM 1' : 'SIM 2'} to ${simStatus ? 'SIM 2' : 'SIM 1'}`;
        addBoxAction({ boxID: box?._id, activity });
        addDeviceActivityNote({ boxID: box?._id, note: activity });
        if (showSpinner) await utils.delay(20000);
        setSpinnerMsg('Please wait, Sim status is updating.');
        if (shouldBoot) {
          const res = await rebootEpikBox(token, box._id);
          if (res) {
            changeAction('reboot epik box');
          }
        } else {
          await geteSIMStatus();
        }
      } else {
        await fetchPrimarySim();
      }
      if (showSpinner) setSimActiveLoading(false);
    } else {
      await fetchPrimarySim();
    }
  };

  const handleESIMSwapStatus = async e => {
    setSimType(e)
  };

  const handleSavePrimarySim = async () => {
    if(simType.value !== ''){
      setShowConfirmModal(true)
    } else {
      await fetchPrimarySim()
    }
  }

  const getWireguardValue = (wgString) => {
    if (wgString?.includes('Enabled')) return true;

    const regex = /:(\s*\d+)/; // Regular expression to match colon followed by digits
    const match = wgString?.match(regex);
    if (match && match[1]) {
      const numberAfterColon = parseInt(match[1].trim(), 10);
      return numberAfterColon === 1;
    }

    return false;
  }

  const getSecondaryStatus = async () => {
    const secondaryStatus = await secondaryTunnelStatus(token, box?._id);
    const wgVal = getWireguardValue(secondaryStatus?.Response);
    setSecTunnel(wgVal);
  };

  const getBoxActiveSimStats = async (token, boxId) => {
    const simStats = await boxActiveSimStats(token, boxId);

    const apnOptions = simStats?.apnArr?.reduce((filteredOpt, currOpt) => {
      const opt = {
        label: currOpt,
        value: currOpt,
      };
      filteredOpt.push(opt);
      return filteredOpt;
    }, []);

    if (!apnOptions) return;
    setApnNameOptions(apnOptions);
    setactiveCarrier(simStats?.activeCarrier);
  };

  const v3Hits = async () => {
    if (!box?.myEpik) {
      await getPriority();
      await getAPN(APNItems[1].value);
      await getCurrentCarrier();
      await setCarrierType(APNItems[1]);
      // geteSIMStatus();
      await getSecondaryStatus();
      await getBoxActiveSimStats(token, box?._id);
    }
  };

  const calculateTimeDifference = () => {
    const newData = new Date();
    const lastClickDate = new Date(box?.epiLastFlip);
    const mintDifference = newData?.getTime() - lastClickDate?.getTime();

    return mintDifference / 60000;
  };

  const initialPowerStatusRequest = async () => {
    let response = await makePowerSaverRequest('STATUS', {});
    if(response?.powerSaveOption){
      setIsPowerSaveOn(true);
      if(response?.powerSaveSchedule?.length){
        setPowerSchedule({on: response?.powerSaveSchedule[0]?.Duration.split(" ")[0], off: response?.powerSaveSchedule[1]?.Duration.split(" ")[0]})
      }
    }
  }

  useEffect(() => {
    v3Hits();
    fetchAutomaticFwDate();
    setPortAlerts(boxOptions?.portAlerts);
    setOfflineProv(boxOptions?.offlineProvision);
    initialPowerStatusRequest();

    const expansion = !box?.expansionBox || (box?.expansionBox && box?.expansionBox?.startsWith('E-') && box?.Obis?.length > 0) ? true : false;
    getBoxesSerialNumber(token, box?.assignedTo?._id, 'yes', expansion);
  }, []);

  const handleSave = () => {
    const data = { ...boxOptions, ...box };
    data.removedSlaves = [];
    const CheckMonitorToggle = true;
    onConfirm(data, CheckMonitorToggle);
  };

  useEffect(() => {
    const divElement = document.getElementById('test-time-remaining');
    const isHidden = divElement.getAttribute('hidden') !== null;
    if (isHidden) {
      setDcLockUpdatePopup({ show: true });
    } else {
      if (!initialRender.current) {
        handleSave()
      } else { 
        initialRender.current = false;
      }
    }
  }, [boxOptions.monitor, boxOptions.e3]);

  const saveOptions = () => {
    handleSave();
    if (!priStatus) {
      priStatusCheck(priStatus);
    }
  };

  const handleUpdateBtnFunc = () => {
    setIsUpdateBtnDisable(true);
  };

  const toggleMonitoring = async () => {
    await updateBox(token, { ...box, monitor: !box?.monitor });

    const message = `Monitoring changed from ${box?.monitor ? 'enabled' : 'disabled'} to ${
      box?.monitor ? ' disabled' : 'enabled'
    }`;

    addAction(message);
    addDeviceActivityNote({ boxID: box?._id, note: message });
  };

  const toggleAdvanceMonitoring = () => {
    if (advMonitoring) {
      advancedMonitoring(!advMonitoring);
      editOptionsChange('advancedMonitoring', !advMonitoring);
    } else if (box?.vpnAddress) {
      advancedMonitoring(!advMonitoring);
      editOptionsChange('advancedMonitoring', !advMonitoring);
    } else {
      toast.error(
        'You can`t enable Advance monitoring because there`s no VPN address listed for this box?.',
      );
    }
  };
  const openPasswordModal = () => {
    setWarningStatus(false);
    setPasswordModalStatus(true);
  };
  const onSecondaryTunnel = async () => {
    if (enableBoxEdit) {
      setSecTunnel(false);
      const secondaryStatusValue = await secondaryTunnel(token, box?._id, secTunnel);
      const wgVal = getWireguardValue(secondaryStatusValue?.result?.Response);
      setSecTunnel(wgVal);
      if (secondaryStatusValue?.checks) {
        const message = `Secondary Tunnel changed from ${secTunnel ? 'enabled' : 'disabled'} to ${
          secTunnel ? 'disabled' : 'enabled'
        }`;
        // add action
        changeAction(message);
        addDeviceActivityNote({ boxID: box?._id, note: message });
      }
    } else {
      console.log('not permitted');
    }
  };
const handleOutOfBandManagementToggle = async (toggleValue, box) => {
  
  setOobmTogglerValue(!toggleValue); // Toggle the Out of Band Management state
  bandToggleHandler(!toggleValue);  
  addBoxAction({
    boxID: box?._id,
    activity: 'changed Out Of Band Management',
  });
  // Add a note for device activity
  addDeviceActivityNote({
    boxID: box?._id,
    note: `Out Of Band Management changed from ${
      !toggleValue ? 'disabled' : 'enabled'
    } to ${!toggleValue ? 'enabled' : 'disabled'}`,
  });
};

  const onPassSecurityModal = async () => {
    setPasswordModalStatus(false);
    if (currentModalData.type === 'monitoring') {
      toggleMonitoring();
    } else if (currentModalData.type === 'secondary') {
      onSecondaryTunnel();
    } else if (currentModalData.type === 'advancedMonitoring') {
      toggleAdvanceMonitoring();
    } else if (currentModalData.type === 'dcAutoUpdate') {
      handleDcAutoUpdateToggle();
    } 
    // else if (currentModalData.type === 'internationalDialing') {
    //   handleInternationalDialingToggle();
    // }
     else if (currentModalData.type === BAND_MANAGEMENT) {
      setCurrentModalData({});
      bandToggleHandler(oobmTogglerValue);
      addBoxAction({ boxID: box?._id, activity: 'changed Out Of Band Management' });
      addDeviceActivityNote({
        boxID: box?._id,
        note: `Out Of Band Management changed from ${
          oobmTogglerValue ? 'disabled' : 'enabled'
        } to ${oobmTogglerValue ? 'enabled' : 'disabled'}`,
      });
    } else if (currentModalData.type === omitLeading9) {
      setCurrentModalData({});
      ext9OverrideToggleHandler(!extValue)
      addBoxAction({ boxID: box?._id, activity: 'changed Omit Leading 9' });
      addDeviceActivityNote({
        boxID: box?._id,
        note: `Omit Leading 9 changed from ${extValue ? 'enabled' : 'disabled'} to ${
          extValue ? 'disabled' : 'enabled'
        }`,
      });
    }
    // else if (currentModalData.type === PIN_CODES_NAME.powerSave) {
    //   setCurrentModalData({});
    //   setIsPowerSaveOn(!isPowerSaveOn);
    //   updatePowerSaveMode(!isPowerSaveOn, selectedPowerSaveMode);
    // }
    else if (currentModalData.type === DATA_CENTER) {
      setIsExpandingBox(true);
      setWarningStatus(false);

      const draftDc = { ...dc };
      const { value, label } = draftDc;
      setIsLoading(true);
      const res = await updateBox(token, {
        ...box,
        datacenter: value,
      });

      res && addDeviceActivityNote({ boxID: box?._id, note: `Data Center changed to ${label}` });

      setLoadingText(`Device Registration Move In Progress… \n Please Wait. This page will refresh in 60 seconds.`)
      const timerId = setTimeout(() => {
        changeAction('datacenter changed');
        window.location.reload();
      }, 60000);
      if (!res) {
        clearTimeout(timerId);
        setIsLoading(false);
        setIsExpandingBox(false);
      }
    }
  };

  const getAPN = async carrier => {
    const res = await getCarrier(token, box?.vpnAddress, carrier);
    if (res) {
      setAPNString(res.apn);
    }
  };

  const getCurrentCarrier = async () => {
    const res = await getCurrentApn(token, box?.vpnAddress);
    if (res) {
      setAPNCurrentString(res.apn);
      setAPNString(res.apn);
    }
  };

  // const getPriority = async () => {
  //   const res = await getInterfacePriorityIsp(token, box?.vpnAddress);
  //   if (res) {
  //     const arr = res.interfaces.split(',').map(s => s.trim()).filter(Boolean);
  //     defaultInterfacePriorite = res;
  //     setInterfacePriorityState_(arr);
  //   } else {
  //     setInterfacePriorityState_(null);
  //   }
  // };
  const [hysteresisByIf, setHysteresisByIf] = useState({});
  const [latencyByIf, setLatencyByIf] = useState({});
  const [prevPrioritySnapshot, setPrevPrioritySnapshot] = useState(null); // just for logging before/after

  const splitCSV = (s = '') =>
  String(s)
    .split(',')
    .map(v => v.trim())
    .filter(Boolean);

const getPriority = async () => {
  const res = await getInterfacePriorityIsp(token, box?.vpnAddress);
  if (res) {
    const ifaceArr = splitCSV(res.interfaces);
    const hystArr = splitCSV(res.HYSTERESIS);
    const latArr = splitCSV(res.latencyTrigger);
    const hystMap = {};
    const latMap = {};
    ifaceArr.forEach((iface, idx) => {
      const hystVal =
        hystArr[idx] ?? hystArr[hystArr.length - 1] ?? '';
      const latVal =
        latArr[idx] ?? latArr[latArr.length - 1] ?? '';
      hystMap[iface] = hystVal;
      latMap[iface] = latVal;
    });

    setHysteresisByIf(hystMap);
    setLatencyByIf(latMap);

    setInterfacePriorityState_(ifaceArr);

    setPrevPrioritySnapshot({
      interfaces: res.interfaces || '',
      HYSTERESIS: res.HYSTERESIS || '',
      latencyTrigger: res.latencyTrigger || '',
    });
  } else {
    setInterfacePriorityState_(null);
  }
};



  // const handleInterfacePriority = async () => {
  //   const priorityOfInterest = [...interfacePriority].join(',');
  //   const res = await setInterfacePriority(token, box?.vpnAddress, priorityOfInterest);
  //   if (res) {
  //     getPriority();
  //     // [Action]- Change
  //     const message = `Interface priority Changed from ${defaultInterfacePriorite} to ${priorityOfInterest}`;
  //     changeAction(message);
  //     addDeviceActivityNote({ boxID: box?._id, note: message });
  //   }
  // };
  const handleInterfacePriority = async () => {
    const DEFAULT_HYSTERESIS = 50;
    const DEFAULT_LATENCY = 500;
    const orderedIfaces = [...interfacePriority];
    const orderedHyst = orderedIfaces.map((iface) => {
      const v = hysteresisByIf?.[iface];
      return (v === undefined || v === null || v === '') ? DEFAULT_HYSTERESIS : v;
    });
    const orderedLat = orderedIfaces.map((iface) => {
      const v = latencyByIf?.[iface];
      return (v === undefined || v === null || v === '') ? DEFAULT_LATENCY : v;
    });
  
    const payload = {
      interfaces: orderedIfaces.join(','),               
      HYSTERESIS: orderedHyst.join(','),                
      latencyTrigger: orderedLat.join(','),            
    };
    const res = await setInterfacePriority(token, box?.vpnAddress,orderedIfaces.join(','), payload);
    if (res) {
      await getPriority();
      const fromIf = prevPrioritySnapshot?.interfaces ?? '';
      const fromHy = prevPrioritySnapshot?.HYSTERESIS ?? '';
      const fromLt = prevPrioritySnapshot?.latencyTrigger ?? '';
      const toIf = payload.interfaces;
      const toHy = payload.HYSTERESIS;
      const toLt = payload.latencyTrigger;
  
      const message = `Interface priority Changed from ${fromIf} to ${toIf}`;
      changeAction(message);
      addDeviceActivityNote({ boxID: box?._id, note: message });
    }
  };

  const handleSetCarrier = async () => {
    const data = {
      carrier: newActiveCarrier,
      apn: newActiveCarrierAPN,
      note:`Active carrier changed to ${newActiveCarrier} and APN changed to ${newActiveCarrierAPN}`
    };

    const res = await setCarrier(token, box?.vpnAddress, data);

    if (res) {
      getAPN(carrierType.value);
      getCurrentCarrier();
      // [Action]- Change
      addBoxAction({ boxID: box?._id, activity: 'APN changed' });
      //Device Activity APN Changed
      await addNote(token, box?._id, data);
    }
  };

  const toggleTooltip = () => setTooltipOpen(!tooltipOpen);
  const toggleTooltipPower = () => setTooltipOpenPower(!tooltipOpenPower);
  const toggleTooltipSave = () => setTooltipOpenSave(!tooltipOpenSave);
  const toggleTooltipSoft = () => setTooltipOpenSoft(!tooltipOpenSoft);
  const toggleTooltipUpdate = () => setTooltipOpenUpdate(!tooltipOpenUpdate);
  const toggleTooltipSuspend = () => setTooltipOpenSuspend(!tooltipOpenSuspend);

  const toggleSimTooltip = () => setSimOpenTooltip(!simOpenTooltip);
  const toggleTooltipM = () => setTooltipOpenM(!tooltipOpenM);

  const handleAPNChange = e => {
    const reg = /^[\.a-zA-Z0-9]*$/g;
    if (reg.test(e.target.value)) {
      setAPNString(e.target.value);
    }
  };

  const handlePortAlerts = async () => {
    setPortAlerts(null);
    setIsExpandingBox(true);
    const data = await updateBox(token, { ...box, portAlerts: !box?.portAlerts });
    if (data) {
      const activity = `${!box?.portAlerts ? 'enabled' : 'disabled'} Port Alerts`;
      const note = `Port Alerts changed from ${box?.portAlerts ? 'enabled' : 'disabled'} to ${
        box?.portAlerts ? 'disabled' : 'enabled'
      }`;
      addBoxAction({ boxID: box?._id, activity });
      addDeviceActivityNote({ boxID: box?._id, note });
    }
    setPortAlerts(data);
    setIsExpandingBox(false);
  };
  const handleOfflineProv = async () => {
    setIsExpandingBox(true);
    setOfflineProv(null);
    const data = await updateBox(token, {
      ...box,
      offlineProvision: !box?.offlineProvision,
    });
    if (data) {
      const message = `Offline Provisioning toggle changed from  ${
        box?.offlineProvision ? 'enabled' : 'disabled'
      } to ${box?.offlineProvision ? 'disabled' : 'enabled'}`;

      changeAction(message);
      addDeviceActivityNote({ boxID: box?._id, note: message });
    }
    setOfflineProv(data);
    setIsExpandingBox(false);
  };

  const move = (from, to, arr = interfacePriority) => {
    const clone = [...arr];
    Array.prototype.splice.call(clone, to, 0, Array.prototype.splice.call(clone, from, 1)[0]);
    setInterfacePriorityState_(clone);
  };

  const e911ModalHandler = (number, showModal, id) => {
    setBoxOptions({ ...boxOptions, e911Number: number });
    setShowQueryLrnModal(showModal);
    setSelectedNumberId(id);
    if (id) {
      setSelectedNumberId(id);
      getAddress(token, id);
    }
  };
  const onValidationClose = () => {
    setShowValidationModal(false);
  };

function extractAddressComponents(input) {
    return {
        AddressLine1: input.address1 || '',
        AddressLine2: input.address2?.trim() || '',
        City: input.city || '',
        StateCode: input.state || '',
        Zip: input.zip || ''
    };
}

    const onUpdate = async (e, enableValidation = false) => {
    optionsBoxChange({ boxOptions });
    // const resApi = await updateAddress(token, selectedNumberId, e);
      // if ((!enableValidation && resApi === false) || resApi === false) {
      let cleanedAddress
      if (!enableValidation) {
        cleanedAddress = extractAddressComponents(e);
        const suggestedDataApi = await GeocodeRequest(token, cleanedAddress);
        const { data, success } = suggestedDataApi;
        if (typeof success === 'boolean' && !success) {
          if (data) {
            setSuggestedData(data);
            setShowValidationModal(true);
            return;
          }
          toast.error('Unable to geocode address. No address suggestions found.');
          return;
        }
      }
    const resApi = await updateAddress(token, selectedNumberId, e);
    if (resApi) {
      setShowValidationModal(false)
      setShowQueryLrnModal(false);
      setHideE911Loader(true);
      setIsE911Verified(true);
      const e911Number = assignedCompanyNumbers?.filter(did => did.number === e?.dn);
      const carrier = e911Number?.length && e911Number[0]?.e911Carrier || '';
      const res = updateBox(token, { ...boxOptions, e911Info: { ...e, vendor: carrier } });
      clearAddress();
      if (res) {
        addBoxAction({ boxID: box?._id, activity: `E911 number updated from ${box?.e911Number || '-'} to ${e.dn}` });
        addDeviceActivityNote({ boxID: box?._id, note: `E911 number updated from ${box?.e911Number || '-'} to ${e.dn}` });
      }
    }
  };
  const onFailoverPress = () => {
    setFailoverStatus(true);
    onFailoverInstall();
  };

  const handleE2Save = async () => {
    const res = await activateE2(token, box?._id, e2Strings);
    if (res) {
      if (box?.e2.IP && !e2Strings.IP) {
        // [Action] - Add
        addAction('Static E1 IP Type added');
      } else {
        // [Action] - Change
        changeAction('Static E1 IP Type changed');
      }
    }
  };

  const onWarningConfirm = async () => {
    const result = await activateE3(token, box?._id);
    if (result) {
      await enableAction(`E2 toggle enabled`);
      setBoxOptions({ ...boxOptions, e3: !boxOptions.e3 });
    }
    setWarningStatus(false);
  };

  const onE3Toggle = async () => {
    if (boxOptions.e3) {
      const result = await deactivateE3(token, box?._id);
      if (result) {
        setBoxOptions({ ...boxOptions, e3: !boxOptions.e3 });
        //[Action] - disabled
        await disableAction(`E2 toggle disabled`);
      }
    } else {
      //[Action] - enabled
      setCurrentModalData(warningText);
      setWarningStatus(true);
    }
  };

  const handleCleare911Num = async () => {
    if (voiceIndicator) {
      toast.error('Please remove voice type ports before clearing E911 number');
      return;
    }
    setIsLoading(true);
    // [Action] - Change

    const assignedE911Number = assignedCompanyNumbers?.filter(num => num?.number === box?.e911Number);
    if (assignedE911Number?.length) {
      const withoutPlusOne = assignedE911Number[0]?.number?.split('+1');
      const body = { dn: withoutPlusOne[1] };
      const selectedNumberId = assignedE911Number[0]?._id;

      const clearE911Number = async () => {
        const res = await updateBox(token, {
          ...boxOptions,
          e911Number: '',
          e911Info: {
            address1: '',
            address2: '',
            callername: '',
            city: '',
            dn: '',
            state: '',
            zip: '',
            locationid: '',
            vendor: ''
          }
        });
    
        if (res) {
          const clearedE911Number = boxOptions.e911Number;
          const activityMsg = `E911 number ${clearedE911Number} cleared`;
          addBoxAction({ boxID: box?._id, activity: activityMsg });
          addDeviceActivityNote({ boxID: box?._id, note: activityMsg });
        }
      };

      if (box?.e911Info?.address1 && addressModalData?.statusCode === '200') {
        // const removeSuccess = await removeNumberAddress(token, selectedNumberId, body);
        const removeSuccess = true;
        if (removeSuccess) {
          setIsE911Verified(false);
          await clearE911Number();
        }
      } else if (box?.e911Number) {
        setIsE911Verified(false);
        await clearE911Number();
      }

    }
    setIsLoading(false);
  };

  const handlePriSip = async () => {
    let boxUpdateResponse = null;
    if (!box?.features?.showPriTab) {
      setIsExpandingBox(true);
      const features = {
        ...box?.features,
        showPriTab: !box?.features?.showPriTab,
      };
      boxUpdateResponse = await updateBox(token, { ...box, features });
      setIsExpandingBox(false);
    } else if (
      priSettings?.numberSettings?.numbers?.length > 0 ||
      sipSettings?.numberSettings?.numbers?.length > 0
    ) {
      toast.error('Please delete all numbers before disabling PRI');
    } else if (box?.features?.pri || box?.features?.sip) {
      toast.error('Please disable both SIP & PRI toggle before disabling SIP || PRI');
    } else {
      setIsExpandingBox(true);
      const features = {
        ...box?.features,
        showPriTab: !box?.features?.showPriTab,
      };
      boxUpdateResponse = await updateBox(token, { ...box, features });
      setIsExpandingBox(false);
    }

    if (boxUpdateResponse) {
      addDeviceActivityNote({
        boxID: box?._id,
        note: `CAS | PRI ${!box?.features?.showPriTab ? 'enabled' : 'disabled'}`,
      });
    }
  };

  const handleDcAutoUpdateToggle = async () => {
    setIsExpandingBox(true);
    const features = {
      ...box?.features,
      dcAutoUpdate: !box?.features?.dcAutoUpdate,
    };
    try {
      await updateBox(token, { ...box, features });
      const message = `Data Center Auto Select ${!box?.features?.dcAutoUpdate ? 'enabled' : 'disabled'}`;
      addDeviceActivityNote({ boxID: box?._id, note: message });
    } catch (error) {
      toast.error('Error occured while setting the data center auto update flag');
    }
    setIsExpandingBox(false);
  };

  const handleInternationalDialingToggle = async () => {
    setIsExpandingBox(true);
    
    const result = await updateInterCalling(token, box?._id, { status: !interDialing });
    if (result) {
      setInterDialing(!interDialing);
      const message = `International Dialing ${!interDialing ? 'enabled' : 'disabled'}`;
      addDeviceActivityNote({ boxID: box?._id, note: message });
    } else {
      toast.error('Error occured while setting the International Dialing.');
    }
    setIsExpandingBox(false);
  }

  const HandleInHousingToggle = async () => {
    setIsExpandingBox(true);
    if (calculateTimeDifference() > 5 || !box?.epiLastFlip) {
      setEnableInhouseToggler(true);
      setBoxOptions({ ...boxOptions, inhouseProvision: !boxOptions.inhouseProvision });
      const res = await updateBox(token, {
        ...box,
        inhouseProvision: !boxOptions.inhouseProvision,
      });
      if (res) {
        if (boxOptions.inhouseProvision) {
          //[Action] - Disable
          await addBoxAction({ boxID: box?._id, activity: 'epik EPI provisioning disabled' });
          await addDeviceActivityNote({ boxID: box?._id, note: 'epik EPI provisioning disabled' });
        } else {
          //[Action] - Enable
          await addBoxAction({ boxID: box?._id, activity: 'epik EPI provisioning enabled' });
          await addDeviceActivityNote({ boxID: box?._id, note: 'epik EPI provisioning enabled' });
        }
      }
      if (!res) {
        setBoxOptions({ ...boxOptions, inhouseProvision: box?.inhouseProvision });
      }
      setEnableInhouseToggler(false);
    } else {
      toast.info('Settings are being sent to EPI. Switch is disabled for 5 minutes');
    }
    setIsExpandingBox(false);
  };

  const handleExpansionBox = async () => {
    const { docs: boxes } = await getEpikBoxesBySerialNumber(token, boxOptions.expansionBox, false);
    const secondaryBox = boxes[0];
    const primaryObis = box?.Obis?.map(item => item._id);

    if (!secondaryBox?.obis?.length) {
      toast.error(`Please add ports to the expansion box and try again.`);
      return;
    }

    setIsExpandingBox(true);
    // update primary box
    const expansionEnable = !disableExpansionModule;
    const response = await updateBox(token, {
      ...box,
      slaveBoxes: [secondaryBox?._id],
      obis: [...primaryObis, ...secondaryBox?.obis],
      Obis: [...primaryObis, ...secondaryBox?.obis],
      expansionBox: boxOptions.expansionBox,
    },expansionEnable);

    if (response) {
      // [Action]- Change
      const note = `Attached Expansion Module: Additional EPIs added to ${box?.serialNumber} device`;
      addBoxAction({ boxID: box?._id, activity: note });
      addDeviceActivityNote({ boxID: box?._id, note: note });

      // update secondary box
      await boxLock(token, secondaryBox._id);
      const res = await updateBox(token, {
        ...secondaryBox,
        masterBox: box._id,
        removedObis: secondaryBox?.obis,
        Obis: [],
      });
      if (res) {
        // [Action]- Change
        const note = `Removed obis from expansion box ${box?.serialNumber}`;
        addBoxAction({ boxID: box?._id, activity: note });
        addDeviceActivityNote({ boxID: box?._id, note: note });
      }
    }

    setIsExpandingBox(false);
  };

  const handleBoxOfflineCallForwardNumber = async e => {
    setIsExpandingBox(true);
    let callForwardEnable = enableOfflineBoxCallForward;
    let callForwardEnableNumber = boxOfflineCallForwardNumber;

    if (callForwardEnable && callForwardEnableNumber) {
      const assignedNumbers = [];
      (box?.Obis || []).forEach((obi) => {
        const n1 = obi?.port1?.assignedNumberRef?.number;
        if (n1) assignedNumbers.push(n1);
        const n2 = obi?.port2?.assignedNumberRef?.number;
        if (n2) assignedNumbers.push(n2);
      });
      if (assignedNumbers.some((assigned) => phoneNumbersMatch(callForwardEnableNumber, assigned))) {
        toast.error(DEVICE_UNAVAILABLE_FORWARD_ERROR);
        setIsExpandingBox(false);
        return;
      }
    }

    setStarToggleLoading(true);
    const res = await enableBoxCallForward(token, box?._id, callForwardEnable, callForwardEnableNumber);
      if (res) {
        setBoxOptions({ ...boxOptions, starCodes: true });
        // [Action] - Enable
        const remoteCallOverflowMsg = 'Device Unavailable Call Forward enabled';
        const starCodeMsg = 'Star Codes enabled';

        addBoxAction({ boxID: box?._id, activity: remoteCallOverflowMsg });
        addBoxAction({ boxID: box?._id, activity: starCodeMsg });
        addDeviceActivityNote({ boxID: box?._id, note: remoteCallOverflowMsg });
        addDeviceActivityNote({ boxID: box?._id, note: starCodeMsg });
      }
      setStarToggleLoading(false);
   
    setIsExpandingBox(false);
  };

  const disableBoxOfflineCallForward = async () => {
    let callForwardEnable = false
    let callForwardEnableNumber = boxOfflineCallForwardNumber
    const res = await enableBoxCallForward(token, box?._id, callForwardEnable, callForwardEnableNumber);
    if (res) {
      setBoxOptions({ ...boxOptions, starCodes: true });
      // [Action] - Enable
      const remoteCallOverflowMsg = 'Device Unavailable Call Forward disabled';
      const starCodeMsg = 'Star Codes enabled';

      addBoxAction({ boxID: box?._id, activity: remoteCallOverflowMsg });
      addBoxAction({ boxID: box?._id, activity: starCodeMsg });
      addDeviceActivityNote({ boxID: box?._id, note: remoteCallOverflowMsg });
      addDeviceActivityNote({ boxID: box?._id, note: starCodeMsg });
    }
    setStarToggleLoading(false);
   
    setIsExpandingBox(false);
  };

  // Added this to turn the old integrated expansion boxes.
  const disableOldExpansionBox = async () => {
    setIsExpandingBox(true);

    const { docs: boxes } = await getEpikBoxesBySerialNumber(token, boxOptions.expansionBox, false);
    const masterBox = boxes[0];

    await boxLock(token, masterBox._id);

    // remove duplicate obis
    const masterObis = masterBox.obis.filter(item => !boxOptions.removedObis.includes(item));

    // update primary box
    const res = await updateBox(token, {
      ...masterBox,
      slaveBoxes: [],
      obis: [...masterObis],
      Obis: [...masterObis],
    },'false');

    if (res) {
      setEnableExpansionBox(!enableExpansionBox);
      // [Action] - Change;
      addBoxAction({ boxID: box?._id, activity: 'Removed Expansion Module: EPIs removed from device' });
    }
    // update secondary box
    const response = await updateBox(token, {
      ...box,
      masterBox: null,
      Obis: [...box.Obis, ...box?.removedObis],
      removedObis: [],
      expansionBox: '',
    });
    setIsExpandingBox(false);
    if (response) {
      // [Action]- Change
      addBoxAction({ boxID: box?._id, activity: 'Removed Expansion Module: EPIs removed from device' });
    }
  };

  const disableExpansionBox = async () => {
    const slaveBox = box?.slaveBoxes[0];

    console.log('slaveBox', slaveBox);

    // find expansion box obis
    const isSlavePortsAssigned = box?.Obis?.filter(item => slaveBox?.removedObis?.includes(item?._id))?.some(
      obi => obi?.port1?.assignedNumberRef || obi?.port2?.assignedNumberRef
    );

    console.log('isSlavePortsAssigned', isSlavePortsAssigned);

    if (isSlavePortsAssigned) {
      toast.error(`There are still ports that are provisioned on this expansion module. Please remove any Numbers assigned to an expansion module port before removing the Expansion module from an EPIK Device.`);
      return;
    }

    // find primary box obis
    const masterObis = box?.Obis?.filter(item => !slaveBox?.removedObis?.includes(item?._id))?.map(
      item => item?._id,
    );
    console.log('masterObis', masterObis);

    // find expansion box obis
    const slaveObis = box?.Obis?.filter(item => slaveBox?.removedObis?.includes(item?._id))?.map(
      item => item?._id,
    );
    console.log('slaveObis', slaveObis);

    if (!slaveObis?.length) {
      toast.error(`Something went wrong. Please try refreshing the page.`);
      return;
    }

    setIsExpandingBox(true);

    // update primary box
    const response = await updateBox(token, {
      ...box,
      Obis: [...masterObis],
      slaveBoxes: [],
      expansionBox: '',
    },'false');

    if (response) {
      setEnableExpansionBox(!enableExpansionBox);

      await boxLock(token, slaveBox._id);
      // update secondary box
      await updateBox(token, {
        ...slaveBox,
        removedObis: [],
        masterBox: null,
        obis: [...slaveObis],
        Obis: [...slaveObis],
      });

      // [Action]- Change
      const note = 'Removed Expansion Module: EPIs removed from device';
      addDeviceActivityNote({ boxID: box?._id, note: note });
      addBoxAction({ boxID: box?._id, activity: note });
    }

    setIsExpandingBox(false);
  };

  const removeValueFromArray = (array, value) => {
    const index = array.indexOf(value);
    if (index !== -1) {
      array.splice(index, 1);
    }
    return array;
  };

  const onHardReset = async () => {
    setCurrentModalData(warningHardReset);
    setWarningStatus(true);
  };

  const handleDeactivateE2 = async () => {
    if (e2Strings.enabled) {
      const res = await deactivateE2(token, box?._id);
      if (res) {
        if (e2Strings.enabled) {
          // [Action]-Disable
          disableAction('E1 IP Type change from enable to disable');
        } else {
          // [Action] - Enable
          enableAction('E1 IP Type change from disabled to enabled');
        }
      }
    }
    setE2Strings({ ...e2Strings, enabled: !e2Strings.enabled });
  };

  const onStarCodeToggle = async e => {
    setIsExpandingBox(true);
    if (!boxOptions.starCodes) {
      setStarToggleLoading(true);
      const res = await enableStarCodes(token, box?._id);
      if (res) {
        setBoxOptions({ ...boxOptions, starCodes: true });
        // [Action] - Enable
        addBoxAction({ boxID: box?._id, activity: 'Star Codes enabled' });
        addDeviceActivityNote({ boxID: box?._id, note: 'Star Codes enabled' });
      }
      setStarToggleLoading(false);
    }
    setIsExpandingBox(false);
  };
  const handleStarReset = async () => {
    setStarResetLoading(true);
    const res = await resetStarCodes(token, box?._id);
    if (res) {
      // [Action] - Disable
      addBoxAction({ boxID: box?._id, activity: 'Star Codes reset' });
      addDeviceActivityNote({ boxID: box?._id, note: 'Star Codes reset' });
    }
    setStarResetLoading(false);
  };

  const onDataCenterSelection = value => {
    const sourceLatency = dataCenterLatency[dc.value];
    const targetLatency = dataCenterLatency[value.value];

    setDc(value);

    if (!sourceLatency && !targetLatency) {
      toast.error('Failed to fetch latency of data centers');
    }
  };

  const updateDCNames = (existingDC, updatedDC) => {
    console.log('updatedDC',updatedDC);
    let existingDCName;
    let updatedDCName;
    switch (existingDC) {
      case 'la':
        existingDCName = 'Los Angeles';
        break;
      case 'ny':
        existingDCName = 'New York';
        break;
      case 'at':
        existingDCName = 'Atlanta';
        break;
      case 'dl':
          existingDCName = 'Dallas';
          break;
      default:
        existingDCName = 'Chicago';
        break;
    }
    switch (updatedDC) {
      case 'la':
        updatedDCName = 'Los Angeles';
        break;
      case 'ny':
        updatedDCName = 'New York';
        break;
      case 'at':
        updatedDCName = 'Atlanta';
        break;
      case 'dl':
        updatedDCName = 'Dallas';
          break;
      default:
        updatedDCName = 'Chicago';
        break;
    }
    return { existingDCName, updatedDCName };
  };

  const onCommit = () => {
    const { existingDCName, updatedDCName } = updateDCNames(box?.datacenter, dc.value);

    datacenterWarningText.subHeader = `Move Device Registration from ${existingDCName} to ${updatedDCName}?`;

    const selectedDC = dc.value;
    if (parseFloat(dataCenterLatency[selectedDC]) > parseFloat(dataCenterLatency[box?.datacenter])) {
      setDcUpdatePopup({ show: true, dc });
    } else {
      setCurrentModalData(datacenterWarningText);
      setWarningStatus(true);
    }
  };

  const onUpdateDC = async () => {
    const boxId = box?._id;

    /* API CALLS => UPDATE LATENCY CALL FOLLOWED BY GET LATENCY CALL AFTER 60 seconds */
    const latencyUpdateResponse = await fetchDataCenterLatency_(boxId, DATA_LATENCY_TYPE.UPDATE_LATENCY);
    if (latencyUpdateResponse) {
      addDeviceActivityNote({ boxID: box?._id, note: 'Latency updated' });
    }
    await utils.sleep(SIXTY_SECONDS_DELAY);
    await fetchDataCenterLatency_(boxId, DATA_LATENCY_TYPE.GET_LATENCY, IGNORE_INFO_TOASTER);
  };

  const onEnhanceRouting = async e => {
    const { checked } = e.target;
    setEnableEnhanceRouting(!enableEnhanceRouting);
  };

  const [showWarningModel, setShowWarningModel] = useState(false);
  const [oobmDisableWarn, setOobmDisableWarn] = useState(false);

  const warningCancelHandler = () => {
    setShowWarningModel(false);
    setIsLoading(false);
  };

  const warningGoHandler = () => {
    oobLoadingHandler(true);
    OOBManagerHandler(true);
  };

  useEffect(() => {
    if (box?.internationalDialing !== interDialing) {
      setInterDialing(box?.internationalDialing);
    }

    if (box.OBEnable !== showIcon) {
      setShowIcon(box.OBEnable);
    }
    setShowWarningModel(false);
  }, [box]);

  const bandToggleHandler = toggleValue => {
    if (toggleValue) {
      setShowWarningModel(true);
    } else {
      setOobmDisableWarn(true)
    }
  };

  const removeOOBService = async () => {
    if(user.role === 'superAdmin' || user.role === 'companyGroupAdmin') {
      oobLoadingHandler(true);
      const res = await removeOob(token, box._id);
      if (res) {
        setShowIcon(false);
        updateOOBDetail();
      }
      oobLoadingHandler(false);
    }
    setOobmDisableWarn(false);
  };

  const ext9OverrideToggleHandler = async (extValue) => {
    setExtLoading(true)
    const res = await ext_9override(token, box.vpnAddress, extValue);
    if (res) {
      setExtValue(extValue)
    }
    setExtLoading(false)
  }

  const handle3DigitDialingToggle = (toggleValue) => {
    const newValue = !toggleValue;
    
    // If turning off, show confirmation modal
    if (newValue === false && enable3DigitDialing === true) {
      setShow3DigitDialingConfirmModal(true);
    } else {
      // If turning on, just update the state
      setEnable3DigitDialing(newValue);
    }
  };

  const handleConfirmDisable3DigitDialing = async () => {
    setShow3DigitDialingConfirmModal(false);
    setEnable3DigitDialing(false);
    setThreeDigitDialingEntries([{ code: '', redirectTo: '' }]);
    
    try {
      await updateThreeDigitDialing({
        isMyEpik: false,
        endpoint: `boxes/${box?._id}/update3digitdiallinglist`,
        method: 'PATCH',
        body: {
          enabled: false,
          entries: {}
        }
      });

      // Refresh the 3-digit dialing data and box data after successful disable
      await fetchThreeDigitDialing();
      getEpikBoxData(token, box?._id);

      setEnable3DigitDialing(box?.threeDigitDialing?.enabled);

      addBoxAction({ boxID: box?._id, activity: 'disabled 3 digit dialing' });
      addDeviceActivityNote({
        boxID: box?._id,
        note: '3 digit dialing has been disabled and all entries cleared',
      });
    } catch (error) {
      console.error('Error disabling 3-digit dialing:', error);
      toast.error('Failed to disable 3-digit dialing');
      // Revert the state on error
      setEnable3DigitDialing(true);
    }
  };

  const handleCancelDisable3DigitDialing = () => {
    setShow3DigitDialingConfirmModal(false);
  };

  const addThreeDigitDialingEntry = () => {
    setThreeDigitDialingEntries([...threeDigitDialingEntries, { code: '', redirectTo: '' }]);
  };

  const updateThreeDigitDialingEntry = (index, field, value) => {
    const updatedEntries = [...threeDigitDialingEntries];
    updatedEntries[index][field] = value;
    setThreeDigitDialingEntries(updatedEntries);
  };

  const removeThreeDigitDialingEntry = (index) => {
    if (threeDigitDialingEntries.length > 1) {
      const updatedEntries = threeDigitDialingEntries.filter((_, i) => i !== index);
      setThreeDigitDialingEntries(updatedEntries);
    }
  };

  const saveThreeDigitDialingConfig = async () => {
    setThreeDigitDialingLoading(true);
    try {
      // Convert all entries to object format (including empty ones)
      const entriesObject = {};
      threeDigitDialingEntries.forEach(entry => {
        if (entry.code) {
          entriesObject[entry.code] = entry.redirectTo || '';
        }
      });

      const requestBody = {
        enabled: enable3DigitDialing,
        entries: entriesObject
      };

      await updateThreeDigitDialing({
        isMyEpik: false,
        endpoint: `boxes/${box?._id}/update3digitdiallinglist`,
        method: 'PATCH',
        body: requestBody
      });
      
      // Refresh the 3-digit dialing data and box data after successful save
      await fetchThreeDigitDialing();
      getEpikBoxData(token, box?._id);
      
      addBoxAction({ boxID: box?._id, activity: 'saved 3 digit dialing configuration' });
      addDeviceActivityNote({
        boxID: box?._id,
        note: `3 digit dialing configuration saved with ${Object.keys(entriesObject).length} entries (including empty ones)`,
      });
      
    } catch (error) {
      console.error('Error saving 3-digit dialing config:', error);
      toast.error('Failed to save 3-digit dialing configuration');
    }
    setThreeDigitDialingLoading(false);
  };
  const epiTimezoneHandler = async () => {
    console.log("generic ", epitTimezoneValue, box.epitTimezone)
    setEpiTimezoneLoading(true)
    const res = await updateBox(token, { ...box, epiTimezone: epitTimezoneValue.value });
    if (res) {
      setEpiTimezoneValue(epitTimezoneValue);
      addDeviceActivityNote({ boxID: box?._id, note: `EPIs Time Zone changed to ${epitTimezoneValue.value}` });
    }
    setTimeout(() => {
      setEpiTimezoneLoading(false)
    }, 500)
  }
  const unLockBoxButton = async () => {
    const element = document.getElementById('test-lock-icon');
    if (element) {
      // Simulate a click event
      element.click();
    } else {
      console.error('Element with id "test-lock-icon" not found.');
    }
  };


  const getPinCodeName = () => {
    let featureName = ''

    switch (currentModalData.type) {
      case 'enhancedFax':
        featureName = PIN_CODES_NAME.faxCode;
        break;
      case DATA_CENTER:
        featureName = PIN_CODES_NAME.datacenterCode;
        break;
      case 'dcAutoUpdate':
        featureName = PIN_CODES_NAME.dcAutoUpdate;
        break;
      case 'internationalDialing':
        featureName = PIN_CODES_NAME.internationalDialing;
        break;
      case BAND_MANAGEMENT:
        featureName = PIN_CODES_NAME.bandManagement;
        break;
      case omitLeading9:
        featureName = PIN_CODES_NAME.omitLeading9;
        break;
      case PIN_CODES_NAME.powerSave:
        featureName =  PIN_CODES_NAME.powerSave;
        break;
      default:
        featureName = currentModalData.type
    }

    return featureName;
  }

  const handlePowerSaveToggle = async () => {
    let response = await makePowerSaverRequest(!isPowerSaveOn ? 'ENABLE': 'DISABLE', {});
    
    if (response) {
      const activity = `Power Save mode ${!isPowerSaveOn ? 'enabled' : 'disabled'}`;
      addDeviceActivityNote({ boxID: box?._id, note: activity });
      setIsPowerSaveOn(!isPowerSaveOn)
    }
  }

  useEffect(() => {
    if (box?.e911Number && addressModalData?.statusCode === '200') {
      setIsE911Verified(true);
    } else {
      setHideE911Loader(true)
    }
  }, [addressModalData])

  useEffect(() => {
    if (box?.e911Number) {
      const suggestions = assignedCompanyNumbers?.filter(did => did.number === box?.e911Number)

      e911ModalHandler(box?.e911Number, false, suggestions[0]?._id);
    }
  }, [])

  const onDbcaAlertToggle = async() => {
    console.log('here... ', dbcaAlert);
    const res = await updateDbcaAlert(token, box._id, !dbcaAlert);
    if (res) {
      setDbcaAlert(!dbcaAlert);
      addDeviceActivityNote({ boxID: box?._id, note: `DBCA Alert ${!dbcaAlert ? 'enabled' : 'disabled'}` });
    }
  }

  const checkThirdOctet = parseInt(box?.vpnAddress?.split('.')[2], 10) >= 20;
  const newExpansionBox = !box?.expansionBox || (box?.expansionBox && box?.expansionBox?.startsWith('E-') && box?.Obis?.length > 0);
  const matchedAssignedNumbers = [];
  box.Obis.forEach((obi) => {
    for (const portKey in obi) {
      const assignedNumber = obi[portKey]?.assignedNumber ? obi[portKey]?.assignedNumber : obi[portKey]?.assignedNumberRef?.number;
      const matchedEntry = assignedCompanyNumbers?.find(entry => entry?.number === assignedNumber);
      if (matchedEntry) {
        matchedAssignedNumbers.push(matchedEntry);
      }
    }
  });
  console.log('matchedAssignedNumbers', matchedAssignedNumbers);

  useEffect(() => {
    if (epikUpdates !== undefined && epikUpdates !== null) {
      setDeviceEpikUpdates(!!epikUpdates);
    }
  }, [epikUpdates]);

  return (
    <div className="optionsContainer">
      {isExpandingBox && <Spinner customText={loadingText} />}
      {user.readOnly ? (
        <div className="error-msg text-center">Unauthorized: Role is readonly.</div>
      ) : (
        <>
        {(user.role != 'admin' &&
        user.role != 'enterpriseAdmin' ) && (
        <>
          {showQueryLrnModal && (
            <E911AddressModal
              openValidationModal={showValidationModal}
              selectedNumberTitle={boxOptions.e911Number}
              data={addressModalData?.entry_query}
              onUpdate={onUpdate}
              isOpen={showQueryLrnModal}
              modalCloseValidation={onValidationClose}
              suggestedData={suggestedData}
              onCancel={() => (setShowQueryLrnModal(false), clearAddress())}
            />
          )}
          <div className="row data-container">
            <div className="box-type-container col-md-10">
              {!box?.myEpik && (
                <Row>
                  <Col
                    sm={3}
                    id="test-e911-number"
                    style={{ marginTop: '10px' }}
                    className="type-header"
                  >
                    E911 Number:
                  </Col>
                  <Col sm={isE911Verified ? 4 : 5}>
                    {matchedAssignedNumbers && matchedAssignedNumbers.length > 0 && (
                      <>
                        <BoxAutocomplete
                          placeholder="Filter Numbers"
                          searchTerm={box?.e911Number}
                          numbers={matchedAssignedNumbers}
                          onChange={e => {
                            if (e.suggestion) {
                              e911ModalHandler(e.value, true, e.suggestion._id);
                            }
                          }}
                        />
                      </>
                    )}
                  </Col>
                  {box?.e911Number && (
                    <Col style={{ padding: "5px" }} sm={isE911Verified ? 3 : 0}>
                      {matchedAssignedNumbers && matchedAssignedNumbers.length > 0 && isE911Verified ? (
                        <>
                          <span style={{ color: "#28a745" }}>
                            <FontAwesomeIcon
                              icon="check-circle"
                              size="lg"
                              color="#28a745"
                              style={{ marginRight: '0.5rem' }}
                            />
                            Address Verified
                          </span>
                        </>
                      ) : !hideE911Loader ? (<SpinnerCircles red />) : ''}
                    </Col>
                  )}
                  <Col sm={2}>
                    {isLoading ? (
                      <SpinnerCircles red />
                    ) : (
                      box?.e911Number && (
                        <Button color="primary" onClick={handleCleare911Num}>
                          Clear
                        </Button>
                      )
                    )}
                  </Col>
                </Row>
              )}
            </div>
{/*             {user.powerSave && (
            <Col md={10} className='box-type-container'>
              <Row>
                <Col sm={5} className='type-header'>Enable Power Save Mode</Col>
                <Col sm={1}>
                  <Toggle value={isPowerSaveOn} onToggle={handlePowerSaveToggle} />
                </Col>
                <Col sm={3} className='pr-2'>
                  {isPowerSaveOn && (
                    <Button color="primary" onClick={() => setPowerSaverModal(true)}>
                      Set Schedule
                    </Button>
                  )}
                  {isPowerSaverModalOpen && (
                    <PowerSaverSchedule
                      isOpen={isPowerSaverModalOpen}
                      modalToggle={setPowerSaverModal}
                      setPowerSchedule={setPowerSchedule}
                      powerSchedule={powerSchedule}
                      box={box}
                    />
                  )}
                </Col>
                <Col sm={3} className='px-1 d-flex align-items-center'>
                  {isPowerSaveOn && !!Object.values(powerSchedule).length && (
                    <span className="text-nowrap">
                      <small>Set: {powerSchedule?.on} Hours on : {powerSchedule?.off} Hours off</small>
                    </span>
                  )}
                </Col>
              </Row>
            </Col>
            )} */}
            {/* Enable 3 Digit Dialing Toggle */}
            <div className="box-type-container col-md-10">
              <Row>
                <Col sm={5} id="test-enable-3-digit-dialing-label" className="type-header d-flex">
                  Enable 3 Digit Dialing:
                </Col>
                <Col sm={2} style={{ display: 'flex', verticalAlign: 'middle' }}>
                  <Toggle
                    id="3-digit-dialing-switch-toggle"
                    value={enable3DigitDialing}
                    onToggle={handle3DigitDialingToggle}
                  />
                </Col>
              </Row>
            </div>

            {/* 3 digit Dialing Configuration Fields */}
            {enable3DigitDialing && (
              <div className="box-type-container col-md-10" style={{ marginBottom: '10px' }}>
                <Row>
                  <Col sm={12}>
                    <h6 style={{ marginBottom: '15px', color: '#333' }}>3 Digit Dialing Configuration</h6>
                    {threeDigitDialingEntries.map((entry, index) => (
                      <Row key={index} style={{ marginBottom: '10px', alignItems: 'center' }}>
                        <Col sm={3}>
                          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                            <Label for={`code-${index}`} style={{ marginRight: '8px', marginBottom: '0', minWidth: '40px' }}>Code:</Label>
                            <Input
                              id={`code-${index}`}
                              type="text"
                              value={entry.code}
                              onChange={(e) => updateThreeDigitDialingEntry(index, 'code', e.target.value)}
                              placeholder="Code"
                              maxLength={3}
                              style={{ width: '80px' }}
                            />
                          </div>
                        </Col>
                        <Col sm={6}>
                          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                            <Label for={`redirect-${index}`} style={{ marginRight: '8px', marginBottom: '0', minWidth: '80px' }}>Redirect To:</Label>
                            <Input
                              id={`redirect-${index}`}
                              type="text"
                              value={entry.redirectTo}
                              onChange={(e) => updateThreeDigitDialingEntry(index, 'redirectTo', e.target.value)}
                              placeholder="Enter redirect to number"
                            />
                          </div>
                        </Col>
                        <Col sm={2} style={{ display: 'flex', alignItems: 'center', paddingBottom: '5px' }}>
                          {index === threeDigitDialingEntries.length - 1 ? (
                            <div style={{ display: 'flex', alignItems: 'center', marginLeft: '15px' }}>
                              <Button
                                color="primary"
                                size="sm"
                                onClick={addThreeDigitDialingEntry}
                                style={{ marginRight: '10px' }}
                              >
                                <FontAwesomeIcon icon={faPlus} />
                              </Button>
                              <Button
                                color="primary"
                                size="sm"
                                onClick={saveThreeDigitDialingConfig}
                                disabled={threeDigitDialingLoading}
                              >
                                {threeDigitDialingLoading ? 'Saving...' : 'Save'}
                              </Button>
                            </div>
                          ) : (
                            <div style={{ marginLeft: '15px' }}>
                              <Button
                                color="danger"
                                size="sm"
                                onClick={() => removeThreeDigitDialingEntry(index)}
                                style={{ fontSize: '16px', fontWeight: 'bold' }}
                              >
                                ×
                              </Button>
                            </div>
                          )}
                        </Col>
                      </Row>
                    ))}
                  </Col>
                </Row>
              </div>
            )}

            {omitLeading && (
              <div className="box-type-container col-md-10">
                <Row>
                  <Col sm={5} id="test-enable-sip-pri-label" className="type-header d-flex">
                    Omit Leading 9:
                    <sup>
                      <InfoPopup id="leading9" text={TOOLTIPS_TEXT.LEADING9} />
                    </sup>
                  </Col>
                  <Col sm={2} style={{ display: 'flex', verticalAlign: 'middle' }}>
                    {extLoading ? (
                      <SpinnerCircles red />
                    ) : (
                      typeof extValue === 'boolean' && (
                        <Toggle
                          id="ext-switch-toggle"
                          value={extValue}
                          disabled={omitLeading === 'read' || extLoading}
                          onToggle={
                            (omitLeading === 'write' || omitLeading === 'both') && !extLoading
                              ? async toggleValue => {
                                  console.log('typeof toggle ', toggleValue);
                                  ext9OverrideToggleHandler(!toggleValue);
                                }
                              : undefined 
                          }
                        />
                      )
                    )}
                  </Col>
                </Row>
              </div>
            )}
            {(outBandManagement === 'read' || outBandManagement === 'both') && (
                // bandManagementStatus &&
              <div className="box-type-container col-md-10">
                <Row>
                  <Col sm={5} id="test-enable-sip-pri-label" className="type-header d-flex">
                    Enable Out of Band Management:
                    <sup>
                      <InfoPopup id="oobm" text={TOOLTIPS_TEXT.Band_MANAGEMENT} />
                    </sup>
                  </Col>
                  <Col sm={2} style={{ display: 'flex', verticalAlign: 'middle' }} id="enable_oobm">
                    {oobLoading ? (
                      <SpinnerCircles red />
                    ) : (
                      <Toggle
                        id="oobm-switch-toggle"
                        disabled={oobLoading || outBandManagement === 'read'}
                        value={showIcon}
                        onToggle={async toggleValue => {
                          if (outBandManagement === 'write' || outBandManagement === 'both') {
                          await handleOutOfBandManagementToggle(toggleValue, box);
                          }
                        }}
                      />
                    )}
                  </Col>
                </Row>
              </div>
            )}

            {/* With the new expansion module logic, it only allows G3-2400-e models devices in the list. */}
            {(!box?.masterBox || (box?.expansionBox && box?.Obis?.length === 0)) && (
              <div className="box-type-container col-md-10">
                <Row className="align-items-center">
                  <Col sm={5} id="test-enable-expansion-box" className="type-header d-flex">
                    {newExpansionBox ? 'Add' : 'Enable'} Expansion Module
                    <sup>
                      <InfoPopup id="enable-exp-module" text={TOOLTIPS_TEXT.ENABLE_EXP_MODULE} />
                    </sup>
                  </Col>

                  <Col sm={2} style={{ display: 'flex', verticalAlign: 'middle' }}>
                    <Toggle
                      value={enableExpansionBox}
                      id="test-enable-expansion-box-toggle"
                      onToggle={e => {
                        if (e && !!box?.expansionBox) {
                          setDisableExpansionModule(true);
                        } else {
                          setEnableExpansionBox(!enableExpansionBox);
                        }
                      }}
                    />
                  </Col>

                  {enableExpansionBox && (boxesSerial?.length > 0 || box?.expansionBox) && (
                    <>
                      <Col sm={7} md={5} style={{ display: "flex", verticalAlign: "middle" }}>
                        <Row>
                          <Col sm={10} md={10} style={{ display: "flex", verticalAlign: "middle" }}>
                            <DynamicAutoComplete
                                isDisabled={!!box?.expansionBox}
                                searchTerm={boxOptions.expansionBox}
                                dropdownList={removeValueFromArray(boxesSerial, box?.serialNumber)}
                                onChange={({ suggestion }) => {
                                  setBoxOptions(prev => ({ ...prev, expansionBox: suggestion }));
                                }}
                                placeholder="Serial Number"
                              />
                          </Col>
                          {!box?.expansionBox ? (
                              <Col md={2}>
                                <Button
                                  color="primary"
                                  onClick={() => {
                                    setEnableExpansionWarning(true);
                                  }}
                                  id="test-dynamic-autocomplete-save-btn"
                                >
                                  Save
                                </Button>
                              </Col>
                            ) : null}
                        </Row>
                      </Col>
                    </>
                  )}
                  {enableExpansionBox && !box?.expansionBox && !boxesSerial?.length && ('No expansion box found.')}
                </Row>
              </div>
            )}
            {utils.checkBoxVersionThirdOctet(box?.vpnAddress) !== 'v2' && box.boxRegistrar === 'Unified' ? (
                <div className="box-type-container col-md-10">
                  <EnhancedRouting user={user} pendingFaxData={pendingFaxData}/>
                </div>
              ) :null
            }
          {utils.checkBoxVersionThirdOctet(box?.vpnAddress) !== 'v2' && !box.advancedRouting ? (
          registrationOffSet && (
          <div className="box-type-container col-md-10">
          <BoxRegistrar registrationOffSet={registrationOffSet}/>
          </div>
           )) : null}
            <div className="box-type-container col-md-10">
              <Row className="align-items-center">
                <Col sm={5} id="test-enable-enhanced-fax" className="type-header d-flex">
                  Enable Enhanced Fax
                </Col>

                <Col sm={2} style={{ display: 'flex', verticalAlign: 'middle' }}>
                  {/* <Toggle
                    value={!!box?.enhancedFax}
                    id="test-enable-enhanced-fax-toggle"
                    onToggle={() => {
                      if (!box?.enhancedFax) {
                        setCurrentModalData(warningEnhancedFax);
                        setWarningStatus(true);
                      } else {
                        setCurrentModalData(warningDisableEnhancedFax);
                        setWarningStatus(true);
                      }
                    }}
                  /> */}
                        <Toggle
                          value={!!box?.enhancedFax}
                          id="test-enable-enhanced-fax-toggle"
                          disabled={hasPendingFaxes}
                          faxDisabled={hasPendingFaxes}
                          customDisableText={
                            hasPendingFaxes
                              ? 'There is currently a fax in progress. Please wait for it to complete or delete it from the Usage->Fax menu.'
                              : undefined
                          }
                          onToggle={() => {
                            if (hasPendingFaxes) return;
                            if (!box?.enhancedFax) {
                              setCurrentModalData(warningEnhancedFax);
                              setWarningStatus(true);
                            } else {
                              setCurrentModalData(warningDisableEnhancedFax);
                              setWarningStatus(true);
                            }
                          }}
                        />
                </Col>
              </Row>
            </div>
            {/* <div className="box-type-container col-md-10">
              <Row>
                <Col id="pricing-toggle" sm={4} className="type-header d-flex">
                  Advance monitoring:
                  <sup>
                    <InfoPopup id="advance-monitoring" text={TOOLTIPS_TEXT.ADV_MONITORING} />
                  </sup>
                </Col>
                <Col sm={8} style={{ display: 'flex', verticalAlign: 'middle' }}>
                  {!enableToggleLoader ? (
                    <Toggle
                      value={advMonitoring}
                      id="test-advance-monitoring-toggle"
                      onToggle={() => {
                        setIsExpandingBox(true);
                        if (enableBoxEdit) {
                          setCurrentModalData(warningAdvancedMonitoringTxt);
                          setWarningStatus(true);
                        } else {
                          console.log('not permitted');
                        }
                      }}
                    />
                  ) : (
                    <div>
                      <SpinnerCircles red />
                    </div>
                  )}
                </Col>
              </Row>
            </div> */}
            <div className="box-type-container col-md-10">
              <Row>
                <Col sm={5} id="pricing-toggle-M" className="type-header d-flex">
                  Port Alerts:
                  <sup>
                    <InfoPopup id="port-alerts" text={TOOLTIPS_TEXT.PORT_ALERT} />
                  </sup>
                </Col>
                {portAlerts === null ? (
                  <div>
                    <SpinnerCircles red />
                  </div>
                ) : (
                  <Col sm={2} style={{ display: 'flex', verticalAlign: 'middle' }}>
                    <Toggle
                      id="test-port-alerts-toggle"
                      value={box?.portAlerts}
                      onToggle={handlePortAlerts}
                    />
                  </Col>
                )}
              </Row>
            </div>
            {/* <div className="box-type-container col-md-10">
              <Row>
                <Col sm={5} id="pricing-toggle-M" className="type-header d-flex">
                  Offline Provisioning:
                  <sup>
                    <InfoPopup id="offline-prov" text={TOOLTIPS_TEXT.OFFLINE_PROV} />
                  </sup>
                </Col>
                {offlineProv === null ? (
                  <div>
                    <SpinnerCircles red />
                  </div>
                ) : (
                  <Col sm={2} style={{ display: 'flex', verticalAlign: 'middle' }}>
                    <Toggle
                      id="test-offline-provisioning-toggle"
                      value={box?.offlineProvision}
                      onToggle={handleOfflineProv}
                    />
                  </Col>
                )}
              </Row>
            </div> */}
            {enableMonitoring && (
            <div className="box-type-container col-md-10">
              <Row>
                <Col sm={5} id="pricing-toggle-M" className="type-header d-flex">
                  Monitoring:
                  <sup>
                    <InfoPopup id="monitoring" text={TOOLTIPS_TEXT.MONITORING} />
                  </sup>
                </Col>
                <Col sm={2} style={{ display: 'flex', verticalAlign: 'middle' }}>
                  <Toggle
                    value={box?.monitor}
                    id="test-price-toggle-M"
                    disabled={enableMonitoring === 'read'}
                    onToggle={() => {
                      // setIsExpandingBox(true);
                      if (enableBoxEdit) {
                        if (enableMonitoring === 'write' || enableMonitoring === 'both') {
                          // setCurrentModalData(warningMonitoringTxt);
                          // setWarningStatus(true);
                          toggleMonitoring();  // Directly call the function to toggle monitoring
                        } else {
                          console.log('Power save not permitted for this operation.');
                        }
                      } else {
                        console.log('Editing not permitted.');
                      }
                    }}
                    
                  />
                </Col>
              </Row>
            </div>
          )}
            <div className="box-type-container col-md-10">
              <Row>
                <Col sm={5} id="dbca_alert" className="type-header d-flex">
                  DBCA Alert:
                  <sup>
                    <InfoPopup id="dbca" text={TOOLTIPS_TEXT.DBCA_ALERT} />
                  </sup>
                </Col>
                <Col sm={2} style={{ display: 'flex', verticalAlign: 'middle' }}>
                  <Toggle
                    value={dbcaAlert}
                    id="test-dbca-alert"
                    onToggle={onDbcaAlertToggle}
                  />
                </Col>
              </Row>
            </div>

            {!box?.myEpik ? (
              <>
                {/* <div className="box-type-container col-md-10">
                  <Row>
                    <Col sm={5} id="test-secondary-tunnel" className="type-header d-flex">
                      Secondary Tunnel:
                      <sup>
                        <InfoPopup id="secondary-tunnel" text={TOOLTIPS_TEXT.SECONDARY_TUNNEL} />
                      </sup>
                    </Col>
                    <Col
                      sm={2}
                      style={{
                        display: 'flex',
                        verticalAlign: 'middle',
                      }}
                    >
                      {secTunnel === null ? (
                        <div>
                          <SpinnerCircles red />
                        </div>
                      ) : (
                        <Toggle
                          id="test-secondary-tunnel-toggle"
                          value={secTunnel}
                          onToggle={() => {
                            // setIsExpandingBox(true);
                            openPasswordModal();
                            setCurrentModalData(secondarySwitch);
                          }}
                        />
                      )}
                    </Col>
                  </Row>
                </div> */}
                <div className="box-type-container col-md-10">
                <Row className="align-items-center">
                <Col sm={3} md={5} id="test-enable-expansion-box" className="type-header d-flex">
                Device Unavailable Call Forward:
                  <sup>
                    <InfoPopup id="remote-call-overflow" text={TOOLTIPS_TEXT.BOX_OFFLINE_CALL_FORWARD} />
                  </sup>
                </Col>
                <Col sm={2} md={2} style={{ display: 'flex', verticalAlign: 'middle' }}>
                  <Toggle
                    value={enableOfflineBoxCallForward}
                    id="test-enable-expansion-box-toggle"
                    onToggle={e => {
                      setIsExpandingBox(true);
                      setEnableOfflineBoxCallForward(!enableOfflineBoxCallForward);
                      if (e && !!box?.boxOfflineCallForward) {
                        setEnableOfflineBoxCallForward(false);

                        disableBoxOfflineCallForward();
                      }
                      setIsExpandingBox(false);
                    }}
                  />
                </Col>
                {enableOfflineBoxCallForward && (
                  <>
                  <Col sm={7} md={5} style={{ display: 'flex', verticalAlign: 'middle' }}>
                  <Row>
                  <Col sm={10} md={10} style={{ display: 'flex', verticalAlign: 'middle' }}>
                    <Input
                          id="active-carrier-input"
                          type="text"
                          value={boxOfflineCallForwardNumber}
                          onChange={(e) => setBoxOfflineCallForwardNumber(e.target.value)} // Update the state when the input changes

                        />
                    </Col>
                    {!box?.expansionBox ? (
                      <Col sm={2} md={2}>
                        <Button
                          color="primary"
                          onClick={() => handleBoxOfflineCallForwardNumber()}
                          id="test-dynamic-autocomplete-save-btn"
                        >
                          Save
                        </Button>
                      </Col>
                    ) : null}
                  
                  </Row>
                  </Col>

                  </>
                )}
              </Row>
          
                </div>
                {/* <div className="box-type-container col-md-10">
                  <Row>
                    <Col sm={5} id="test-start-code" className="type-header d-flex">
                      Star Codes:
                      <sup>
                        <InfoPopup id="star-code" text={TOOLTIPS_TEXT.STAR_CODES} />
                      </sup>
                    </Col>
                    <Col
                      sm={2}
                      style={{
                        display: 'flex',
                        verticalAlign: 'middle',
                      }}
                    >
                      {starToggleLoading ? (
                        <div>
                          <SpinnerCircles red />
                        </div>
                      ) : (
                        <Toggle
                          id="test-start-code-toggle"
                          disabled={boxOptions.starCodes}
                          value={boxOptions.starCodes}
                          onToggle={onStarCodeToggle}
                        />
                      )}
                    </Col>
                    {boxOptions.starCodes && (
                      <Col sm={2}>
                        {starResetLoading ? (
                          <Spinner customText={spinnerMsg} />
                        ) : (
                          <Button
                            color="primary"
                            onClick={handleStarReset}
                            id="test-start-code-reset-btn"
                          >
                            Reset
                          </Button>
                        )}
                      </Col>
                    )}
                  </Row>
                </div> */}
                {box?.modems.length < 2 && (
                  <div className="box-type-container col-md-10">
                    {parseInt(box?.vpnAddress?.split('.')[2]) > 20 && (
                      <Row>
                        <Col
                          sm={4}
                          id="test-sim-priority"
                          style={{ marginTop: '10px' }}
                          className="type-header d-flex"
                        >
                          SIM Priority
                          <sup>
                            <InfoPopup id="sim-prior" text={TOOLTIPS_TEXT.SIM_PRIOR} />
                          </sup>
                        </Col>
                        <Col sm={4}>
                          <DropdownSelect
                            disabled={!enableBoxEdit}
                            options={SIMItems}
                            selectedOption={simType}
                            onSelect={handleESIMSwapStatus}
                          />
                        </Col>
                        <Col sm={2}>
                          {simActiveLoading ? (
                            <Spinner customText={spinnerMsg} />
                          ) : (
                            <Button
                              color="primary"
                              onClick={handleSavePrimarySim}
                              id="test-sim-priority-save-btn"
                            >
                              Save
                            </Button>
                          )}
                        </Col>
                        <Col sm={2}>
                          {!reloadSimStatus && (
                            <div
                              className="d-flex justify-content-flex-start align-items-center"
                              onClick={onReloadStatus}
                              id="test-reload-btn"
                            >
                              <div className="reload-toggle">
                                <FontAwesomeIcon icon={faRedo} className="fa-icon" />
                              </div>
                            </div>
                          )}
                        </Col>
                      </Row>
                    )}
                    <Row className="mt-3">
                      <Col
                        sm={4}
                        // id="pricing-toggle-M"
                        className="type-header d-flex"
                        id="test-active-sim-label"
                      >
                        Active SIM:
                        <sup>
                          <InfoPopup id="active-sim" text={TOOLTIPS_TEXT.ACTIVE_SIM} />
                        </sup>
                      </Col>
                      <Col sm={8} style={{ display: 'flex', verticalAlign: 'middle' }}>
                        <Input
                          id="test-active-sim-input"
                          type="text"
                          disabled
                          value={boxESimStatus ? 'SIM 2' : 'SIM 1'}
                        />
                      </Col>
                    </Row>
                  </div>
                )}
                <div className="box-type-container col-md-10">
                  <Row>
                    <Col
                      sm={4}
                      id="test-interface-priority-label"
                      style={{ marginTop: '10px' }}
                      className="type-header d-flex"
                    >
                      Interface Priority:
                      <sup>
                        <InfoPopup id="interface-prior" text={TOOLTIPS_TEXT.INTERFACE_PRIOR} />
                      </sup>
                    </Col>
                    {interfacePriority !== null ? (
                      <>
                        <Col sm={6} style={{ display: 'flex', verticalAlign: 'middle' }}>
                          <MultiInputDrag
                            type="interfacePriority"
                            inputData={interfacePriority}
                            move={move}
                            disabledAdmin
                          />
                        </Col>
                        <Col sm={2}>
                          <Button
                            color="primary"
                            onClick={handleInterfacePriority}
                            id="test-interface-priority-save-btn"
                          >
                            Save
                          </Button>
                        </Col>
                      </>
                    ) : (
                      <Col sm={8}>
                        <Alert style={{ width: '100%' }} color="info">
                          Priority could not be fetched
                        </Alert>
                      </Col>
                    )}
                  </Row>
                </div>

                {/* <div className="box-type-container col-md-10">
                  <Row>
                    <Col sm={4} id="pricing-toggle-M" className="type-header">
                      Enable E2:
                    </Col>
                    <Col sm={8} style={{ display: 'flex', verticalAlign: 'middle' }}>
                      <Toggle
                        value={boxOptions.e3}
                        onToggle={() => {
                          onE3Toggle();
                        }}
                      />
                    </Col>
                  </Row>
                </div> */}

                <div className="box-type-container col-md-10">
                  <Row>
                    <Col
                      sm={4}
                      id="test-apn"
                      style={{ marginTop: '10px' }}
                      className="type-header d-flex"
                    >
                      Active Carrier:
                      <sup>
                        <InfoPopup id="apn" text={TOOLTIPS_TEXT.ACTIVE_CARRIER} />
                      </sup>
                    </Col>
                    {activeCarrier ? (
                      <Col sm={8}>
                        <Input
                          id="active-carrier-input"
                          type="text"
                          disabled
                          value={activeCarrier}
                        />
                      </Col>
                    ) : (
                      <div>
                        <SpinnerCircles red />
                      </div>
                    )}
                  </Row>
                </div>
                <div className="box-type-container col-md-10">
                  <Row>
                    <Col
                      sm={4}
                      // id="pricing-toggle-M"
                      className="type-header d-flex"
                      id="test-current-vpn-label"
                    >
                      Current APN:
                      <sup>
                        <InfoPopup id="current-apn" text={TOOLTIPS_TEXT.CURRENT_APN} />
                      </sup>
                    </Col>
                    <Col sm={8} style={{ display: 'flex', verticalAlign: 'middle' }}>
                      <Input
                        id="test-current-vpn-input"
                        type="text"
                        disabled
                        value={APNCurrentString}
                      />
                    </Col>
                  </Row>
                </div>
                <div className="box-type-container col-md-10">
                  <Row>
                    <Col
                      sm={3}
                      id="test-apn-management"
                      style={{ marginTop: '10px' }}
                      className="type-header d-flex"
                    >
                      Set APN For:
                      <sup>
                        <InfoPopup id="apn-management" text={TOOLTIPS_TEXT.APN_MANAGEMENT} />
                      </sup>
                    </Col>
                    <Col sm={3}>
                      <DropdownSelect
                        placeholder="Please select Carrier"
                        disabled={!enableBoxEdit}
                        options={APNItems}
                        selectedOption={{
                          label: newActiveCarrier?.toUpperCase(),
                          value: newActiveCarrier,
                        }}
                        onSelect={value => {
                          setNewActiveCarrier(value.value);
                          setNewActiveCarrierAPN('');
                          setCustomApn(false);
                        }}
                      />
                    </Col>
                    <Col sm={4}>
                      {customApn ? (
                        <Input
                          id="test-custom-apn-input"
                          type="text"
                          defaultValue={newActiveCarrierAPN}
                          onChange={ev => {
                            setAPNString(ev?.target?.value);
                            setNewActiveCarrierAPN(ev?.target?.value);
                          }}
                        />
                      ) : (
                        <DropdownSelect
                          placeholder="Please select APN"
                          disabled={!newActiveCarrier}
                          options={carrierAPNs[newActiveCarrier] || carrierAPNs.verizon}
                          selectedOption={{
                            label:
                              newActiveCarrierAPN?.toUpperCase() || carrierAPNs?.verizon[0]?.label,
                            value: newActiveCarrierAPN || carrierAPNs?.verizon[0]?.value,
                          }}
                          onSelect={value => {
                            if (value?.value === 'custom') {
                              setCustomApn(true);
                              setNewActiveCarrierAPN('');
                            } else {
                              setAPNString(value.value);
                              setNewActiveCarrierAPN(value.value);
                            }
                          }}
                        />
                      )}
                    </Col>
                    <Col sm={2}>
                      <Button
                        disabled={!newActiveCarrierAPN}
                        color="primary"
                        onClick={handleSetCarrier}
                        id="test-apn-save-btn"
                      >
                        Save
                      </Button>
                    </Col>
                  </Row>
                </div>
              </>
            ) : null}
            {!box?.myEpik && (
              <div className="box-type-container col-md-10">
                {/* <Row>
                  <Col id="call-recording-toggle" sm={5} className="type-header d-flex">
                    Enable Call Recording:
                    <sup>
                      <InfoPopup id="enable-call" text={TOOLTIPS_TEXT.ENABLE_CALL_RECOR} />
                    </sup>
                  </Col>

                  {isCallRecorderLoading ? (
                    <div>
                      <SpinnerCircles red />
                    </div>
                  ) : (
                    <Col sm={2} style={{ display: 'flex', verticalAlign: 'middle' }}>
                      <Toggle
                        id="test-call-recording-toggle"
                        value={boxOptions.recording}
                        onToggle={onCallRecordingToggle}
                      />
                    </Col>
                  )}
                </Row> */}
                <Row>
                  <Col id="call-recording-toggle" sm={5} className="type-header d-flex">
                    Enable Call Recording:
                    <sup>
                      <InfoPopup id="enable-call" text={TOOLTIPS_TEXT.ENABLE_CALL_RECOR} />
                    </sup>
                  </Col>

                  {isCallRecorderLoading ? (
                    <div>
                      <SpinnerCircles red />
                    </div>
                  ) : (
                    <Col sm={7} style={{ display: 'flex', alignItems: 'center' }}>
                      {/* Toggle for enabling/disabling call recording */}
                      <Toggle
                        id="test-call-recording-toggle"
                        value={isToggleOn}
                        onToggle={handleToggle}
                      />

                      {/* Show radio buttons only when toggle is ON */}
                      {(isToggleOn && boxOptions.recording && boxOptions.recordingDuration) ? (
                        <div className='call-rec-duration-label'>
                         <CountDownTimer expirationDate={boxOptions.recordingDuration} customStyles={{ 
                          color: '#db4251', 
                          fontSize: '13px',
                          marginTop: '4px'
                          }} />
                        </div>
                      ) : (isToggleOn) && (
                        <>
                          <div style={{ display: 'flex', alignItems: 'center', marginLeft: '15px' }}>
                            <label style={{ display: 'flex', alignItems: 'center', marginRight: '10px', marginTop: '4px' }}>
                              <input
                                type="radio"
                                name="callRecordingDuration"
                                value="24"
                                checked={recordingDuration === 24}
                                onChange={(e) => setRecordingDuration(Number(e.target.value))}
                              />
                             <span style={{ marginLeft: '5px' }}>24h</span>
                            </label>
                            
                            <label style={{ display: 'flex', alignItems: 'center', marginRight: '10px', marginTop: '4px'}}>
                              <input
                                type="radio"
                                name="callRecordingDuration"
                                value="48"
                                checked={recordingDuration === 48}
                                onChange={(e) => setRecordingDuration(Number(e.target.value))}
                              />
                              <span style={{ marginLeft: '5px' }}>48h</span>
                            </label>
                            
                            <label style={{ display: 'flex', alignItems: 'center', marginRight: '10px', marginTop: '4px' }}>
                              <input
                                type="radio"
                                name="callRecordingDuration"
                                value="72"
                                checked={recordingDuration === 72}
                                onChange={(e) => setRecordingDuration(Number(e.target.value))}
                              />
                              <span style={{ marginLeft: '5px' }}>72h</span>
                            </label>

                            <Button color="primary call-rec-execute-btn" onClick={() => { setRecordingModal(true) }}>
                              Execute
                            </Button>
                          </div>
                        </>
                      )
                      }
                    </Col>
                  )}
                </Row>
              </div>
            )}
            <div className="box-type-container col-md-10">
              <Row>
                <Col id="test-epi-provisioning-label" sm={5} className="type-header d-flex">
                  epik EPI provisioning:
                  <sup>
                    <InfoPopup id="epi-prov" text={TOOLTIPS_TEXT.EPIK_PROV} />
                  </sup>
                </Col>
                {!enableInhouseToggler ? (
                  <Col sm={2} style={{ display: 'flex', verticalAlign: 'middle' }}>
                    <Toggle
                      id="test-epi-provisioning-toggle"
                      value={boxOptions.inhouseProvision}
                      onToggle={HandleInHousingToggle}
                    />
                  </Col>
                ) : (
                  <div>
                    <SpinnerCircles red />
                  </div>
                )}
              </Row>
            </div>
            {!box?.myEpik && checkThirdOctet && !isModelGen4 && (
              <div className="box-type-container col-md-10">
                <Row>
                  <Col sm={5} id="test-enable-sip-pri-label" className="type-header d-flex">
                    Enable PRI | CAS:
                    <sup>
                      <InfoPopup id="enable-sip" text={TOOLTIPS_TEXT.ENABLE_SIP} />
                    </sup>
                  </Col>
                  <Col sm={2} style={{ display: 'flex', verticalAlign: 'middle' }}>
                    <Toggle
                      id="test-enable-sip-pri-toggle"
                      value={box?.features?.showPriTab}
                      onToggle={handlePriSip}
                    />
                  </Col>
                </Row>
              </div>
            )}
            <div className="box-type-container col-md-10">
              <Row>
                <Col sm={5} id="test-enable-sip-pri-label" className="type-header d-flex">
                  Data Center Auto Select:
                  <sup>
                    <InfoPopup id="dc-auto-switch" text={TOOLTIPS_TEXT.DC_AUTO_SWITCH} />
                  </sup>
                </Col>
                <Col sm={2} style={{ display: 'flex', verticalAlign: 'middle' }}>
                  <Toggle
                    id="dc-auto-switch-toggle"
                    value={box?.features?.dcAutoUpdate}
                    onToggle={async () => {
                      if (!box?.features?.dcAutoUpdate) {
                        setCurrentModalData({ type: 'dcAutoUpdate' });
                        setPasswordModalStatus(true);
                      } else {
                        handleDcAutoUpdateToggle();
                      }
                    }}
                  />
                </Col>
              </Row>
            </div>
            {internationalDialingAccess && (
            <div className="box-type-container col-md-10">
              <Row>
                <Col sm={5} id="test-enable-sip-pri-label" className="type-header d-flex">
                  Allow International Dialing:
                  <sup>
                    <InfoPopup id="international-dialing" text={TOOLTIPS_TEXT.INTERNATIONAL_DIALING} />
                  </sup>
                </Col>
                <Col sm={2} style={{ display: 'flex', verticalAlign: 'middle' }}>
                  <Toggle
                    id="international-dialing-toggle"
                    value={interDialing}
                    disabled={internationalDialingAccess === 'read'}
                    customDisableText={
                      internationalDialingAccess === 'read'
                        ? 'You do not have permission to perform this action.'
                        : undefined
                    }
                    onToggle={async () => {
                      if (internationalDialingAccess === 'write' || internationalDialingAccess === 'both') {
                        await handleInternationalDialingToggle();
                      }
                    }}
                  />
                </Col>
              </Row>
            </div>
      )}

            <div className="box-type-container col-md-10">
              <Row style={{ alignItems: 'center' }}>
                <Col sm={5} md={4} id="test-enable-sip-pri-label" className="type-header d-flex">
                  EPIs Time Zone:
                  <sup>
                    <InfoPopup id="epi-timezone" text={TOOLTIPS_TEXT.EPI_TIMEZONE} />
                  </sup>
                </Col>
                <Col sm={5} md={4} style={{ display: 'flex', verticalAlign: 'middle' }}>
                  <DropdownSelect
                    disabled={epitTimezoneLoading}
                    selectedOption={epitTimezoneValue}
                    options={timezoneOptions}
                    onSelect={(option) => {
                      console.log("timezone options", option)
                      // epiTimezoneHandler(value)
                      setEpiTimezoneValue(option)
                    }}
                  />
                </Col>
                <Col sm={2} md={4} id="test-enable-sip-pri-label" className="type-header d-flex">
                  {epitTimezoneLoading ? <SpinnerCircles red /> :
                    <Button color="primary" onClick={epiTimezoneHandler} id="test-sim-priority-save-btn">
                      Save
                    </Button>}
                </Col>
              </Row>
            </div>

            {checkThirdOctet && dataCenter && (
              <div className="box-type-container col-md-10">
                <Row style={{ alignItems: 'self-end' }}>
                  {/* <Col sm={4} id="test-enable-sip-pri-label" className="type-header d-flex">
                    Data Center:
                    <sup>
                      <InfoPopup id="data-center" text={TOOLTIPS_TEXT.DATA_CENTER} />
                    </sup>
                  </Col> */}
                        <Col sm={4} id="test-enable-sip-pri-label" className="type-header">
                          <div className="d-flex">
                            Data Center:
                            <sup>
                              <InfoPopup id="data-center" text={TOOLTIPS_TEXT.DATA_CENTER} />
                            </sup>
                          </div>

                          {hasPendingFaxes && (
                            <small
                              style={{
                                color: 'red',
                                display: 'block',
                                marginTop: '8px',
                                lineHeight: '1.4',
                                fontWeight: 400,
                              }}
                            >
                              There is currently a fax in progress. Please wait for it to complete or
                              delete it from the Usage-&gt;Fax menu.
                            </small>
                          )}
                        </Col>

                  <Col
                    sm={6}
                    style={{
                      display: 'flex',
                      gap: '5px',
                      whiteSpace: 'noWrap',
                      alignItems: 'flex-end',
                    }}
                  >
                    <div>
                      {dcLoading ? (
                        <SpinnerCircles red />
                      ) : (
                        // <DropdownSelect
                        //   options={dcOptionsWithLatency}
                        //   selectedOption={dc}
                        //   disabled={dataCenter === 'read'}
                        //   onSelect={value => {
                        //     onDataCenterSelection(value);
                        //   }}
                        // />
                                <DropdownSelect
                                  options={dcOptionsWithLatency}
                                  selectedOption={dc}
                                  disabled={dataCenter === 'read' || hasPendingFaxes}
                                  onSelect={value => {
                                    if (hasPendingFaxes) return;
                                    onDataCenterSelection(value);
                                  }}
                                />
                      )}
                    </div>
                    <div className="last-update-box">
                      {/* <p className="last-update-label">
                        {centerLatencyState?.data?.timeUpdated &&
                          `Last Updated:  `}
                        <span style={centerLatencyState?.data?.timeUpdated && utils.isOlderThan24Hours(centerLatencyState.data.timeUpdated) ? { color: 'red', fontWeight: 500 } : {}}>
                          {centerLatencyState?.data?.timeUpdated && utils.getDateTimeFormat(centerLatencyState?.data?.timeUpdated, 'both')}
                        </span>
                      </p> */}
                      <div
                        style={{
                          display: 'flex',
                          verticalAlign: 'middle',
                          gap: '5px',
                          whiteSpace: 'noWrap',
                        }}
                      >
                        {(dataCenter === 'write' || dataCenter === 'both') && (
                        <Button color="primary" onClick={onCommit} id="test-sim-priority-save-btn"  disabled={hasPendingFaxes}>
                          Commit
                        </Button>
                        )}
                        {(dataCenter === 'write' || dataCenter === 'both') &&(
                          <Button color="primary" onClick={onUpdateDC} id="test-sim-priority-save-btn"  disabled={hasPendingFaxes}>
                            Update Latency
                          </Button>
                          )}
                      </div>
                    </div>
                  </Col>
                </Row>
                      <Col sm={{ span: 4, offset: 6 }} id="test-enable-sip-pri-label" className="type-header d-flex">
                        <div style={{ display: 'inline-block', textDecoration: 'none', borderBottom: 0 }}>
                      
                          <div
                            style={{
                              width: 'fit-content',
                              margin: '6px auto 0',
                              textAlign: 'left',
                              lineHeight: 1.25,
                              fontSize: 12,
                              color: 'black',
                              textDecoration: 'none',
                              borderBottom: 0,
                            }}
                          >
                            {(() => {
                              const history = Array.isArray(box?.dataCenterChangeHistory) ? box.dataCenterChangeHistory : [];
                              const latest = history
                                .filter(r => r && r.changedOn)
                                .sort((a, b) => new Date(b.changedOn) - new Date(a.changedOn))[0]?.changedOn || null;
                              const displayDate = latest ? latest : ''
                              const isOld = latest ? utils.isOlderThan24Hours(latest) : false;
                              return (
                                <div>
                                  Data Center Registered On:{' '}
                                  <span
                                    style={{
                                      fontWeight: 500,
                                      textDecoration: 'none',
                                      borderBottom: 0,
                                    }}
                                  >
                                    {utils.getDateTimeFormat(displayDate, 'both')}
                                  </span>
                                </div>
                              );
                            })()}
                            <div style={{ marginTop: 2 }}>
                              Latency Last Updated:{' '}
                              <span
                                style=
                                {
                                  centerLatencyState?.data?.timeUpdated &&
                                    utils.isOlderThan24Hours(centerLatencyState.data.timeUpdated)
                                    ? { color: 'red', fontWeight: 500, textDecoration: 'none', borderBottom: 0 }
                                    : { fontWeight: 500, textDecoration: 'none', borderBottom: 0 }
                                }
                              >
                                {centerLatencyState?.data?.timeUpdated &&
                                  utils.getDateTimeFormat(centerLatencyState?.data?.timeUpdated, 'both')}
                              </span>
                            </div>
                          </div>
                        </div>
                      </Col>
              </div>
            )}
          </div>
          </>
        )}
            <ConfirmationModal
              bodyText={
                'A device reboot is required for the SIM priority change to take effect. Would you like to reboot now?'
              }
              confirmBtnText={'Yes'}
              isOpen={showConfirmModal}
              onCancel={() => {
                 handleActiveSim(false, false);
                 setShowConfirmModal(false)
              }}
              onConfirm={() => {
                handleActiveSim(true, true);
                setShowConfirmModal(false)
              }}
              closeBtnText={'No'}
            />    

          <ConfirmationModal
            bodyText={
              'You are about to move this device to a data center with slower latency. Are you sure you want to continue?'
            }
            confirmBtnText={'Continue'}
            isOpen={dcUpdatePopup.show}
            onCancel={() => {
              setDcUpdatePopup({ show: false, value: {} });
              setDc(datacenters.find(dc => dc.value === box?.datacenter));
            }}
            onConfirm={() => {
              setDcUpdatePopup({ show: false, value: {} });
              setCurrentModalData(datacenterWarningText);
              setWarningStatus(true);
            }}
          />      
          <ConfirmationModal
          bodyText={'You are attempting to make changes to a device that is not currently locked for editing. To prevent conflicting changes, please lock the device before proceeding.'}
          headerText={'Device Lock Required'}
          confirmBtnText={'Lock & Edit'}
          close={'No'}
          isOpen={dcLockUpdatePopup.show}
          onCancel={() => {
            setDcLockUpdatePopup({ show: false, value: {} });
          }}
          onConfirm={() => {
            unLockBoxButton();
            setDcLockUpdatePopup({ show: false, value: {} });
          }}
        />
  
        {(user.role != 'admin' &&
          user.role != 'enterpriseAdmin' ) && (
          <>
          {!box.myEpik && (
            <div className="reboot-btn-footer">
              {/* {interfacePriority === null && (
                <Button
                  id="test-fail-over-btn"
                  className="options-btns"
                  disabled={failoverStatus}
                  color="primary"
                  onClick={onFailoverPress}
                >
                  Failover Install
                </Button>
              )} */}
            </div>
          )}
          </>
        )}
          <CustomModal
            header="Device Updates"
            isOpen={isUpdateBtnDisable}
            onCancel={() => setIsUpdateBtnDisable(false)}
            close={true}
            submitDisplay
          >
              {deviceEpikUpdates === null
                ? 'Data is still being retrieved. Please wait…'
                : 'EPIK Updates have been disabled by Engineering for this Device.'}
          </CustomModal>

          {showWarningModel && (
            <BandManagementWarningModal
              headText={`Out of band management`}
              isOpen={showWarningModel}
              goHandler={warningGoHandler}
              cancelHandler={warningCancelHandler}
              loading={oobLoading}
            />
          )}

          <div className="epiFooter bottom-btn d-flex justify-content-between options-tab-footer">
            <div className="d-flex">
              <Button
                hidden={
                  !['superAdmin', 'companyGroupAdmin', 'supportEngineer','admin','enterpriseAdmin'].some(
                    x => x === user.role,
                  ) || box?.myEpik
                }
                className="opt-btns"
                color="default"
                onClick={onHardReset}
              >
                <img
                  id="test-power-cycle-btn"
                  style={{ width: '35px' }}
                  src={powerCycle}
                  alt="power Cycle"
                />
                <Tooltip
                  placement="top"
                  isOpen={tooltipOpenPower}
                  target="test-power-cycle-btn"
                  toggle={toggleTooltipPower}
                >
                  Power Cycle
                </Tooltip>
              </Button>
              {(user.role != 'admin' &&
                user.role != 'enterpriseAdmin' ) && (
                <>
              <Button
                disabled={!enableBoxEdit}
                className="opt-btns"
                color="default"
                onClick={saveOptions}
              >
                <img id="test-save-btn" style={{ width: '35px' }} src={save} alt="Save" />
                <Tooltip
                  placement="top"
                  isOpen={tooltipOpenSave}
                  target="test-save-btn"
                  toggle={toggleTooltipSave}
                >
                  Save
                </Tooltip>
              </Button>
              </>
              )}
              <Button
                hidden={
                  (user.role !== 'superAdmin' && user.role !== 'companyGroupAdmin') || box?.myEpik
                }
                color="default"
                className="opt-btns"
                id="test-suspend-restore-btn"
                onClick={async () => {
                  {
                    box?.enabled
                      ? setCurrentModalData(suspendedTxt)
                      : setCurrentModalData(restoreSuspension);
                  }
                  setWarningStatus(true);
                }}
              >
                <img style={{ width: '35px' }} src={suspend} alt={box?.enabled ? 'Suspend Service' : 'Restore Service'} />
                <Tooltip
                  placement="top"
                  isOpen={tooltipOpenSuspend}
                  target="test-suspend-restore-btn"
                  toggle={toggleTooltipSuspend}
                >
                  {box?.enabled ? 'Suspend Service' : 'Restore Service'}
                </Tooltip>
              </Button>
              <Button className="opt-btns" color="default" onClick={onReboot}>
                <img
                  id="test-soft-reboot-btn"
                  style={{ width: '35px' }}
                  src={softReboot}
                  alt="Soft Reboot"
                />
                <Tooltip
                  placement="top"
                  isOpen={tooltipOpenSoft}
                  target="test-soft-reboot-btn"
                  toggle={toggleTooltipSoft}
                >
                  Soft Reboot
                </Tooltip>
              </Button>
            </div>
            {(user.role != 'admin' &&
              user.role != 'enterpriseAdmin' ) && (
              <>
            <div className="last-update-box">
              <Button
                // color={box?.epikUpdateStatus ? 'secondary' : 'primary'}
                className="opt-btns opt-update"
                color="default"
                // onClick={!deviceEpikUpdates ? handleUpdateBtnFunc : onApplyUpdate}
                onClick={() => {
                  if (deviceEpikUpdates === null) {
                    setIsUpdateBtnDisable(true);
                    return;
                  }
                  (!deviceEpikUpdates ? handleUpdateBtnFunc : onApplyUpdate)();
                }}
              >
                <img
                  id="test-apply-updates-btn"
                  style={{ width: '35px' }}
                  src={applyUpdates}
                  alt="Apply Updates"
                />
                <Tooltip
                  placement="top"
                  isOpen={tooltipOpenUpdate}
                  target="test-apply-updates-btn"
                  toggle={toggleTooltipUpdate}
                >
                  Apply Updates
                </Tooltip>
              </Button>
              <p className="last-update-label">
                Last Manually Updated: 
                <span style={box?.firmwareUpdatedOn && utils.isOlderThan24Hours(box.firmwareUpdatedOn) ? { color: 'red', fontWeight: 500 } : {}}>
                  {' '} {utils.getDateTimeFormat(box?.firmwareUpdatedOn, 'both')}
                </span>
              </p>
              <p className="last-update-label">
                Last Automatic Update Installed: 
                <span style={(automaticFwDate?.response || box?.nightlyUpdateTime) && utils.isOlderThan24Hours(automaticFwDate?.response || box?.nightlyUpdateTime) ? { color: 'red', fontWeight: 500 } : {}}>
                  {' '} {utils.getDateTimeFormat(automaticFwDate?.response || box?.nightlyUpdateTime, 'both')}
                </span>
              </p>
            </div>
            </>
            )}
          </div>
        </>
      )}

      <CustomModal
        showCustomButton
        customButtonText="Ok"
        header="Alert"
        isOpen={recordingModal}
        headerIcon={alertErrorMessageWarning}
        onCancel={() => {
          setIsExpandingBox(false);
          setRecordingModal(false);
          onCallRecordingToggle();
        }}
      >
        Recording will be kept for 14 days.
      </CustomModal>

      <ConfirmationModal
        isOpen={warningStatus}
        onCancel={() => {
          setWarningStatus(false);
          setIsExpandingBox(false);
        }}
        confirmBtnText={currentModalData.type === 'datacenter' ? "Move" : currentModalData.type === 'suspension2' ? 'Suspend' : false}
        bodyText={currentModalData.msg}
        subHeader={currentModalData.type === 'datacenter' ? currentModalData?.subHeader : null}
        headerText={currentModalData.type === 'datacenter' ? currentModalData?.header : null}
        onConfirm={async () => {
          if (currentModalData.type === 'datacenter') {
            const ports = obisToPort(box?.Obis, box?.lastUpdated);
            if (ports.some(p => ['fax', 'faxStandard'].includes(p.serviceName)) && dc.value === 'ch')
              setNumberConfirmation(true);

            onPassSecurityModal();
            // setPasswordModalStatus(true);
            setWarningStatus(false);
          } else if (currentModalData.type === 'enhancedFax') {
            setWarningStatus(false);
            const res = await updateBox(token, {
              ...boxOptions,
              enhancedFax: true,
            });
            if (res) {
              // [Action] - Change
              addBoxAction({ boxID: box?._id, activity: 'changed Enhanced Fax' });
              addDeviceActivityNote({ boxID: box?._id, note: 'Enhanced Fax changed from disabled to enabled' });
            }
          } else if (
            currentModalData.type === 'monitoring' ||
            currentModalData.type === 'advancedMonitoring'
          ) {
            openPasswordModal();
          } else if (
            currentModalData.type === 'suspension1' ||
            currentModalData.type === 'suspension2'
          ) {
            setSuspendModal(currentModalData.type === 'suspension1');
            setWarningStatus(false);
            if (currentModalData.type === 'suspension2') {
              const obj = {
                note,
                type: 'user',
              };
              const autoNote = {
                note: `Service Suspended by ${user.name}`,
                type: 'system',
              };

              const res = await updateBox(token, {
                ...boxOptions,
                enabled: false,
                integrated: false,
                refreshSuspendedDate: true,
              });
              if (res) addNote(token, box._id, obj);
              if (res) addNote(token, box._id, autoNote);
              if (res) {
                // [Action] - Change
                changeAction('Service Suspended');
              }
            }
            setWarningStatus(false);
          } else if (currentModalData.type === 'restore') {
            const obj = {
              note: `Service Restored by ${user.name}`,
              type: 'system',
            };
            const res = await updateBox(token, {
              ...boxOptions,
              enabled: true,
              refreshSuspendedDate: true,
            });
            if (res) addNote(token, box._id, obj);
            if (res) {
              // [Action] - Change
              changeAction('Service restored');
            }
            setWarningStatus(false);
          } else if (currentModalData.type === 'hardReset') {
            setWarningStatus(false);
            // setIsExpandingBox(true);
            const res = await boxHardReset(token, box?.vpnAddress);
            if (res) {
              // [Action] - Enable
              await enableAction('Hard Reset');
              addDeviceActivityNote({ boxID: box?._id, note: 'Hard Reboot Epik Box' });
            }
            // setIsExpandingBox(false);
          } else if (currentModalData.type === 'disableEnhancedFax') {
            const res = await updateBox(token, {
              ...boxOptions,
              enhancedFax: false,
            });
            if (res) {
              // [Action] - Change
              addBoxAction({ boxID: box?._id, activity: 'changed Enhanced Fax' });
              addDeviceActivityNote({ boxID: box?._id, note: 'Enhanced Fax changed from enabled to disabled' });
              setWarningStatus(false);
            }
          } else {
            onWarningConfirm();
          }
        }}
      />
      <CustomModal
        confirmBtnText={'Save'}
        isOpen={suspendModal}
        onCancel={() => setSuspendModal(false)}
        onConfirm={() => {
          setWarningStatus(true);
          setCurrentModalData(suspendedTxt1);
        }}
      >
        <FormGroup row>
          <Col>
            <Label>Reason For Suspension</Label>
            <Input
              required
              type="textarea"
              name="suspensionNote"
              placeholder="Enter Note"
              value={note}
              onChange={e => setSuspensionNote(e.target.value)}
            />
          </Col>
        </FormGroup>
      </CustomModal>
      <AddSecurityCodeModal
        isOpen={passwordModalStatus}
        onConfirm={onPassSecurityModal}
        onCancel={() => {
          setWarningStatus(false);
          setCurrentModalData({});
          setPasswordModalStatus(false);
          setIsExpandingBox(false);
        }}
        // modalname='secondarytunneltoggle  scndrytnlupdate'
        // modalname='monitoring, advanceMonitering'
        featureName={getPinCodeName()}
      />
      {numberConfirmation && (
        <WarningModal
          body={
            'Faxing services will be migrated to the Enhanced Fax protocol. Fax services may be interrupted during the migration process. Validate all fax settings after the migration is complete. Do you want to proceed?'
          }
          isOpen={numberConfirmation}
          onCancel={() => {
            setCurrentModalData({});
            setWarningStatus(false);
            setPasswordModalStatus(false);
            setNumberConfirmation(false);
          }}
          onConfirm={() => {
            setNumberConfirmation(false);
          }}
        />
      )}
      {disableExpansionModule && (
        <WarningModal
          body={
            'Are you sure you want to disable the expansion module?'
          }
          isOpen={disableExpansionModule}
          onCancel={() => {
            setDisableExpansionModule(false);
          }}
          onConfirm={() => {
            setDisableExpansionModule(false);
            newExpansionBox ? disableExpansionBox() : disableOldExpansionBox()
          }}
        />
      )}
      {oobmDisableWarn && (
        <WarningModal
          title={'WARNING'}
          body={OOBM_DISABLE_TEXT}
          isOpen={oobmDisableWarn}
          onCancel={() => {
            setOobmDisableWarn(false);
          }}
          onConfirm={() => {
            removeOOBService();
          }}
        />
      )}
      {enableExpansionWarning && (
        <WarningModal
          title={'WARNING'}
          body={ENABLE_EXPANSION_WARNING_TEXT}
          isOpen={enableExpansionWarning}
          onCancel={() => {
            setEnableExpansionWarning(false);
            setEnableExpansionBox(!enableExpansionBox);
          }}
          onConfirm={() => {
            setEnableExpansionWarning(false);
            handleExpansionBox();
          }}
          yesButtonText={'Reboot now'}
          noButtonText={'Cancel'}
        />
      )}
      
      {/* 3 Digit Dialing Disable Confirmation Modal */}
      <ConfirmationModal
        isOpen={show3DigitDialingConfirmModal}
        headerText="Disable 3 Digit Dialing"
        bodyText="Are you sure you want to disable 3 digit dialing? This will clear all existing dialing codes and redirects."
        onCancel={handleCancelDisable3DigitDialing}
        onConfirm={handleConfirmDisable3DigitDialing}
        confirmButtonText="Yes, Disable"
        cancelButtonText="Cancel"
      />
    </div>
  );
};

const mapStateToProps = state => ({
  companies: state.AppState.companies,
  editCompanyGroupData: state.UIState.companies.editCompanyGroupData || '',
  boxesSerial: state.AppState.boxesSerial,
  centerLatency: state.AppState.boxDetails.dataCenterLatency,
  boxesList: state.AppState.boxes,
  optionsBoxUpdate: state.UIState.epikBoxes.optionsBoxUpdate.optionsBox,
  addressModalData: state.AppState.provisioning.address,
  box: state.AppState.boxDetails.box,
  user: state.AppState.user,
  lockStatusBox: state.UIState.epikBoxes.lockStatusEpikBox,
  boxESimStatus: state.UIState.epikBoxes.boxESimStatus,
  assignedCompanyNumbers: state.AppState.obis.assignedCompanyNumbers,
});

const mapDispatchToProps = dispatch => ({
  editOptionsChange: (name, value) => dispatch(BoxesActions.editOptionsChange(name, value)),
  optionsBoxChange: boxData => dispatch(BoxesActions.optionsBoxChange(boxData)),
  getBoxesSerialNumber: (token, compId, paginateOptions, expansion) => dispatch(BoxesActions.getEpikBoxesSerial(token, compId, paginateOptions, expansion)),
  updateAddress: (token, numId, body) => dispatch(updateAddress(token, numId, body)),
  setInterfacePriority: (token, vpn, priorityOfInterest,value) => dispatch(BoxesActions.setInterfacePriority(token, vpn,priorityOfInterest, value)),
  boxHardReset: (token, vpn) => dispatch(BoxesActions.boxHardReset(token, vpn)),
  getInterfacePriority: (token, vpn) => dispatch(BoxesActions.getInterfacePriority(token, vpn)),
  getInterfacePriorityIsp: (token, vpn) => dispatch(BoxesActions.getInterfacePriorityIsp(token, vpn)),
  setCarrier: (token, vpn, value) => dispatch(BoxesActions.setCarrier(token, vpn, value)),
  getCarrier: (token, vpn, carrier) => dispatch(BoxesActions.getCarrier(token, vpn, carrier)),
  getCurrentApn: (token, vpn) => dispatch(BoxesActions.getCurrentApn(token, vpn)),
  getAddress: (token, numId) => dispatch(getAddress(token, numId)),
  clearAddress: () => dispatch(clearAddress()),
  updateBox: (token, box,expansionEnable) => dispatch(BoxesActions.updateEpikBox(token, box,expansionEnable)),
  getEpikBoxData: (token, boxId) => dispatch(BoxesActions.getEpikBoxData(token, boxId)),
  updateInterCalling: (token, bid, body) => dispatch(BoxesActions.updateInterCalling(token, bid, body)),
  activateE2: (token, boxId, body) => dispatch(BoxesActions.activateE2(token, boxId, body)),
  deactivateE2: (token, boxId) => dispatch(BoxesActions.deactivateE2(token, boxId)),
  activateE3: (token, boxId) => dispatch(BoxesActions.activateE3(token, boxId)),
  deactivateE3: (token, boxId) => dispatch(BoxesActions.deactivateE3(token, boxId)),
  enableRecording: (token, boxId, recordingDuration) => dispatch(BoxesActions.enableRecording(token, boxId, recordingDuration)),
  disableRecording: (token, boxId) => dispatch(BoxesActions.disableRecording(token, boxId)),
  addAction: description => dispatch(addAction(description)),
  disableAction: description => dispatch(disableAction(description)),
  enableAction: description => dispatch(enableAction(description)),
  changeAction: description => dispatch(changeAction(description)),
  addNote: (token, id, note) => dispatch(BoxesActions.addNote(token, id, note)),
  getEpikBoxesBySerialNumber: (token, serialNumber, online, pagination) =>
    dispatch(BoxesActions.getEpikBoxesBySerialNumber(token, serialNumber, online, pagination)),
  boxLock: (token, bid) => dispatch(BoxesActions.boxLock(token, bid)),
  eSIMStatus: (token, bid) => dispatch(BoxesActions.eSIMStatus(token, bid)),
  getPrimarySim: (token, bid) => dispatch(BoxesActions.getPrimarySim(token, bid)),
  setPrimarySim: (token, eSIMStatusValue, bid) =>
    dispatch(BoxesActions.setPrimarySim(token, eSIMStatusValue, bid)),
  rebootEpikBox: (token, bid) => dispatch(BoxesActions.rebootEpikBox(token, bid)),
  secondaryTunnel: (token, boxId, secTunnel) => dispatch(BoxesActions.secondaryTunnel(token, boxId, secTunnel)),
  secondaryTunnelStatus: (token, boxId) => dispatch(BoxesActions.secondaryTunnelStatus(token, boxId)),
  enableStarCodes: (token, boxId) => dispatch(BoxesActions.enableStarCodes(token, boxId)),
  enableBoxCallForward: (token, boxId, callForwardEnable, callForwardNumber) => dispatch(BoxesActions.enableBoxCallForward(token, boxId, callForwardEnable, callForwardNumber)),
  resetStarCodes: (token, boxId) => dispatch(BoxesActions.resetStarCodes(token, boxId)),
  boxActiveSimStats: (token, boxId) => dispatch(BoxesActions.boxActiveSimStats(token, boxId)),
  getBoxConnectedUsb: (token, boxId, vpnAddress) => dispatch(BoxesActions.getBoxConnectedUsbs(token, boxId, vpnAddress)),
  removeOob: (token, params) => dispatch(BoxesActions.removeOob(token, params)),
  updateOOBDetail: (token, params) => dispatch(BoxesActions.updateOOBDetail(token, params)),
  ext_9override: (token, vpnAddress, extValue) => dispatch(BoxesActions.ext_9override(token, vpnAddress, extValue)),
  updateDbcaAlert: (token, boxId, dbcaValue) => dispatch(BoxesActions.updateDbcaAlert(token, boxId, dbcaValue)),
  removeNumberAddress: (token, id, body) =>
    dispatch(ProvisioningActions.removeNumberAddress(token, id, body)),
  GeocodeRequest: (token, body) =>
    dispatch(BoxesActions.GeocodeRequest(token, body)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EpikboxOptions);
